// Generated by purs version 0.15.15
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_List from "../Data.List/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Pitches_Class from "../Data.Pitches.Class/index.js";
import * as Data_Pitches_Spelled from "../Data.Pitches.Spelled/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Console from "../Effect.Console/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
var writeImpl = /* #__PURE__ */ Simple_JSON.writeImpl(Simple_JSON.writeForeignString);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var toUnfoldable = /* #__PURE__ */ Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray);
var alter = /* #__PURE__ */ Data_Map_Internal.alter(Data_Ord.ordString);
var ordTuple = /* #__PURE__ */ Data_Tuple.ordTuple(Data_Ord.ordString)(Data_Ord.ordString);
var alter1 = /* #__PURE__ */ Data_Map_Internal.alter(ordTuple);
var ordPitch = /* #__PURE__ */ Data_Pitches_Class.ordPitch(Data_Pitches_Spelled.ordSInterval);
var compare = /* #__PURE__ */ Data_Ord.compare(ordPitch);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var insert = /* #__PURE__ */ Data_Map_Internal.insert(Data_Ord.ordString);
var insert1 = /* #__PURE__ */ Data_Map_Internal.insert(ordTuple);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var readImpl = /* #__PURE__ */ Simple_JSON.readImpl(Simple_JSON.readString);
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var fail = /* #__PURE__ */ Foreign.fail(Data_Identity.monadIdentity);
var alt = /* #__PURE__ */ Control_Alt.alt(/* #__PURE__ */ Control_Monad_Except_Trans.altExceptT(Data_List_Types.semigroupNonEmptyList)(Data_Identity.monadIdentity));
var map1 = /* #__PURE__ */ Data_Functor.map(/* #__PURE__ */ Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity));
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Ordering.eqOrdering);
var eq1 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Pitches_Class.eqPitch(Data_Pitches_Spelled.eqSIC));
var pc = /* #__PURE__ */ Data_Pitches_Class.pc(Data_Pitches_Spelled.hasIntervalClassSInterval);
var add = /* #__PURE__ */ Data_Semiring.add(Data_Semiring.semiringInt);
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var genericShowSum = /* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "NoParents";
    }
}));
var VertParentIsSymbol = {
    reflectSymbol: function () {
        return "VertParent";
    }
};
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var leftIsSymbol = {
    reflectSymbol: function () {
        return "left";
    }
};
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons(leftIsSymbol);
var rightIsSymbol = {
    reflectSymbol: function () {
        return "right";
    }
};
var showRecordFieldsConsNil = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil(rightIsSymbol);
var MergeParentsIsSymbol = {
    reflectSymbol: function () {
        return "MergeParents";
    }
};
var idIsSymbol = {
    reflectSymbol: function () {
        return "id";
    }
};
var showRecordFieldsCons1 = /* #__PURE__ */ Data_Show.showRecordFieldsCons(idIsSymbol);
var pitchIsSymbol = {
    reflectSymbol: function () {
        return "pitch";
    }
};
var showRecord1 = /* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons1(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(pitchIsSymbol)(/* #__PURE__ */ Data_Pitches_Class.showPitch(Data_Pitches_Spelled.notationPitchSInterval)))(Data_Show.showString));
var showRecordFieldsCons2 = /* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "leftParent";
    }
});
var ornIsSymbol = {
    reflectSymbol: function () {
        return "orn";
    }
};
var showRecordFieldsCons3 = /* #__PURE__ */ Data_Show.showRecordFieldsCons(ornIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "rightParent";
    }
})(showRecord1));
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var for_ = /* #__PURE__ */ Data_Foldable.for_(Effect.applicativeEffect)(Data_List_Types.foldableList);
var passingIsSymbol = {
    reflectSymbol: function () {
        return "passing";
    }
};
var regularIsSymbol = {
    reflectSymbol: function () {
        return "regular";
    }
};
var explIsSymbol = {
    reflectSymbol: function () {
        return "expl";
    }
};
var noteIsSymbol = {
    reflectSymbol: function () {
        return "note";
    }
};
var genericShowSum1 = /* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "Freeze";
    }
}));
var showRecordFieldsCons4 = /* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "childl";
    }
});
var showRecordFieldsConsNil1 = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "childr";
    }
});
var showRecordFieldsCons5 = /* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "op";
    }
});
var SplitIsSymbol = {
    reflectSymbol: function () {
        return "Split";
    }
};
var showRecordFieldsCons6 = /* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "childm";
    }
});
var HoriIsSymbol = {
    reflectSymbol: function () {
        return "Hori";
    }
};
var power = /* #__PURE__ */ Data_Monoid.power(Data_Monoid.monoidString);
var intercalate = /* #__PURE__ */ Data_Foldable.intercalate(Data_List_Types.foldableList)(Data_Monoid.monoidString);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_List_Types.functorList);
var isStep = /* #__PURE__ */ Data_Pitches_Class.isStep(Data_Pitches_Spelled.diatonicSIC);
var ic = /* #__PURE__ */ Data_Pitches_Class.ic(Data_Pitches_Spelled.hasIntervalClassSInterval);
var pto = /* #__PURE__ */ Data_Pitches_Class.pto(Data_Pitches_Spelled.intervalSInterval);
var degree = /* #__PURE__ */ Data_Pitches_Spelled.degree(/* #__PURE__ */ Data_Pitches_Spelled.spelledPitch(Data_Pitches_Spelled.spelledSIC)(Data_Pitches_Spelled.hasIntervalClassSICSIC)(Data_Pitches_Spelled.spelledSIC));
var notEq = /* #__PURE__ */ Data_Eq.notEq(Data_Ordering.eqOrdering);
var direction = /* #__PURE__ */ Data_Pitches_Class.direction(Data_Pitches_Spelled.intervalSIC);
var compare1 = /* #__PURE__ */ Data_Ord.compare(Data_Pitches_Spelled.ordSIC);
var unison = /* #__PURE__ */ Data_Pitches_Class.unison(Data_Pitches_Spelled.intervalSIC);
var ordRecord = /* #__PURE__ */ Data_Ord.ordRecord();
var ordRecordCons = /* #__PURE__ */ Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)();
var scanl = /* #__PURE__ */ Data_Traversable.scanl(Data_Traversable.traversableArray);
var fromFoldable = /* #__PURE__ */ Data_List.fromFoldable(Data_Foldable.foldableArray);
var eqPitch = /* #__PURE__ */ Data_Pitches_Class.eqPitch(Data_Pitches_Spelled.eqSInterval);
var eq4 = /* #__PURE__ */ Data_Eq.eq(eqPitch);
var eqRec = /* #__PURE__ */ Data_Eq.eqRec();
var eqRowCons = /* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)();
var eqRec1 = /* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons(pitchIsSymbol)(eqPitch))()(idIsSymbol)(Data_Eq.eqString));
var bind1 = /* #__PURE__ */ Control_Bind.bind(Control_Bind.bindArray);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Control_Applicative.applicativeArray);
var bind2 = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var foldl = /* #__PURE__ */ Data_Foldable.foldl(Data_Foldable.foldableArray);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(Data_Ord.ordString);
var bind3 = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var pure3 = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var discard2 = /* #__PURE__ */ discard(Data_Either.bindEither);
var show1 = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var map3 = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var append2 = /* #__PURE__ */ Data_Semigroup.append(Data_List_Types.semigroupList);
var all = /* #__PURE__ */ Data_Foldable.all(Data_Set.foldableSet)(Data_HeytingAlgebra.heytingAlgebraBoolean);
var toUnfoldable1 = /* #__PURE__ */ Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
var insertWith = /* #__PURE__ */ Data_Map_Internal.insertWith(ordPitch);
var unionWith = /* #__PURE__ */ Data_Map_Internal.unionWith(ordPitch);
var max = /* #__PURE__ */ Data_Ord.max(Data_Ord.ordInt);
var map4 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var TransId = function (x) {
    return x;
};
var Start = /* #__PURE__ */ (function () {
    function Start() {

    };
    Start.value = new Start();
    return Start;
})();
var Inner = /* #__PURE__ */ (function () {
    function Inner(value0) {
        this.value0 = value0;
    };
    Inner.create = function (value0) {
        return new Inner(value0);
    };
    return Inner;
})();
var Stop = /* #__PURE__ */ (function () {
    function Stop() {

    };
    Stop.value = new Stop();
    return Stop;
})();
var TrebleStaff = /* #__PURE__ */ (function () {
    function TrebleStaff() {

    };
    TrebleStaff.value = new TrebleStaff();
    return TrebleStaff;
})();
var BassStaff = /* #__PURE__ */ (function () {
    function BassStaff() {

    };
    BassStaff.value = new BassStaff();
    return BassStaff;
})();
var GrandStaff = /* #__PURE__ */ (function () {
    function GrandStaff() {

    };
    GrandStaff.value = new GrandStaff();
    return GrandStaff;
})();
var SliceId = function (x) {
    return x;
};
var RightRepeat = /* #__PURE__ */ (function () {
    function RightRepeat() {

    };
    RightRepeat.value = new RightRepeat();
    return RightRepeat;
})();
var RightNeighbor = /* #__PURE__ */ (function () {
    function RightNeighbor() {

    };
    RightNeighbor.value = new RightNeighbor();
    return RightNeighbor;
})();
var NoParents = /* #__PURE__ */ (function () {
    function NoParents() {

    };
    NoParents.value = new NoParents();
    return NoParents;
})();
var VertParent = /* #__PURE__ */ (function () {
    function VertParent(value0) {
        this.value0 = value0;
    };
    VertParent.create = function (value0) {
        return new VertParent(value0);
    };
    return VertParent;
})();
var MergeParents = /* #__PURE__ */ (function () {
    function MergeParents(value0) {
        this.value0 = value0;
    };
    MergeParents.create = function (value0) {
        return new MergeParents(value0);
    };
    return MergeParents;
})();
var LeftRepeat = /* #__PURE__ */ (function () {
    function LeftRepeat() {

    };
    LeftRepeat.value = new LeftRepeat();
    return LeftRepeat;
})();
var LeftNeighbor = /* #__PURE__ */ (function () {
    function LeftNeighbor() {

    };
    LeftNeighbor.value = new LeftNeighbor();
    return LeftNeighbor;
})();
var FullNeighbor = /* #__PURE__ */ (function () {
    function FullNeighbor() {

    };
    FullNeighbor.value = new FullNeighbor();
    return FullNeighbor;
})();
var FullRepeat = /* #__PURE__ */ (function () {
    function FullRepeat() {

    };
    FullRepeat.value = new FullRepeat();
    return FullRepeat;
})();
var LeftRepeatOfRight = /* #__PURE__ */ (function () {
    function LeftRepeatOfRight() {

    };
    LeftRepeatOfRight.value = new LeftRepeatOfRight();
    return LeftRepeatOfRight;
})();
var RightRepeatOfLeft = /* #__PURE__ */ (function () {
    function RightRepeatOfLeft() {

    };
    RightRepeatOfLeft.value = new RightRepeatOfLeft();
    return RightRepeatOfLeft;
})();
var PassingMid = /* #__PURE__ */ (function () {
    function PassingMid() {

    };
    PassingMid.value = new PassingMid();
    return PassingMid;
})();
var PassingLeft = /* #__PURE__ */ (function () {
    function PassingLeft() {

    };
    PassingLeft.value = new PassingLeft();
    return PassingLeft;
})();
var PassingRight = /* #__PURE__ */ (function () {
    function PassingRight() {

    };
    PassingRight.value = new PassingRight();
    return PassingRight;
})();
var NoExpl = /* #__PURE__ */ (function () {
    function NoExpl() {

    };
    NoExpl.value = new NoExpl();
    return NoExpl;
})();
var RootExpl = /* #__PURE__ */ (function () {
    function RootExpl() {

    };
    RootExpl.value = new RootExpl();
    return RootExpl;
})();
var HoriExpl = /* #__PURE__ */ (function () {
    function HoriExpl(value0) {
        this.value0 = value0;
    };
    HoriExpl.create = function (value0) {
        return new HoriExpl(value0);
    };
    return HoriExpl;
})();
var RightExpl = /* #__PURE__ */ (function () {
    function RightExpl(value0) {
        this.value0 = value0;
    };
    RightExpl.create = function (value0) {
        return new RightExpl(value0);
    };
    return RightExpl;
})();
var LeftExpl = /* #__PURE__ */ (function () {
    function LeftExpl(value0) {
        this.value0 = value0;
    };
    LeftExpl.create = function (value0) {
        return new LeftExpl(value0);
    };
    return LeftExpl;
})();
var DoubleExpl = /* #__PURE__ */ (function () {
    function DoubleExpl(value0) {
        this.value0 = value0;
    };
    DoubleExpl.create = function (value0) {
        return new DoubleExpl(value0);
    };
    return DoubleExpl;
})();
var Freeze = /* #__PURE__ */ (function () {
    function Freeze() {

    };
    Freeze.value = new Freeze();
    return Freeze;
})();
var Split = /* #__PURE__ */ (function () {
    function Split(value0) {
        this.value0 = value0;
    };
    Split.create = function (value0) {
        return new Split(value0);
    };
    return Split;
})();
var Hori = /* #__PURE__ */ (function () {
    function Hori(value0) {
        this.value0 = value0;
    };
    Hori.create = function (value0) {
        return new Hori(value0);
    };
    return Hori;
})();
var writeForeignTransId = Simple_JSON.writeForeignInt;
var writeForeignStartStop = function (dictWriteForeign) {
    var writeImpl1 = Simple_JSON.writeImpl(dictWriteForeign);
    return {
        writeImpl: function (v) {
            if (v instanceof Start) {
                return writeImpl("start");
            };
            if (v instanceof Stop) {
                return writeImpl("stop");
            };
            if (v instanceof Inner) {
                return writeImpl1(v.value0);
            };
            throw new Error("Failed pattern match at ProtoVoices.Model (line 292, column 15 - line 295, column 27): " + [ v.constructor.name ]);
        }
    };
};
var writeForeignSliceId = Simple_JSON.writeForeignInt;
var transEdges = function (trans) {
    return append(toUnfoldable(trans.edges.regular))(trans.edges.passing);
};
var stylesUpdateNote = function (f) {
    return function (id) {
        return function (styles) {
            return {
                edges: styles.edges,
                slices: styles.slices,
                transitions: styles.transitions,
                css: styles.css,
                staff: styles.staff,
                notes: alter(f)(id)(styles.notes)
            };
        };
    };
};
var stylesUpdateEdge = function (f) {
    return function (id) {
        return function (styles) {
            return {
                notes: styles.notes,
                slices: styles.slices,
                transitions: styles.transitions,
                css: styles.css,
                staff: styles.staff,
                edges: alter1(f)(id)(styles.edges)
            };
        };
    };
};
var startSlice = /* #__PURE__ */ (function () {
    return {
        id: 0,
        notes: Start.value,
        x: 0.0,
        parents: NoParents.value
    };
})();
var staffType2JS = function (v) {
    if (v instanceof GrandStaff) {
        return "grand";
    };
    if (v instanceof TrebleStaff) {
        return "treble";
    };
    if (v instanceof BassStaff) {
        return "bass";
    };
    throw new Error("Failed pattern match at ProtoVoices.Model (line 489, column 16 - line 492, column 22): " + [ v.constructor.name ]);
};
var sortNotes = /* #__PURE__ */ Data_Array.sortBy(function (a) {
    return function (b) {
        return Data_Ordering.invert(compare(a.note.pitch)(b.note.pitch));
    };
});
var thawSlice = function (slice) {
    return function (id) {
        return {
            id: id,
            notes: new Inner(map(function (n) {
                return {
                    note: n.note,
                    expl: NoExpl.value
                };
            })(sortNotes(slice))),
            x: Data_Int.toNumber(id),
            parents: NoParents.value
        };
    };
};
var showTransId = {
    show: function (v) {
        return "t" + show(v);
    }
};
var show2 = /* #__PURE__ */ Data_Show.show(showTransId);
var showStartStop = function (dictShow) {
    var show7 = Data_Show.show(dictShow);
    return {
        show: function (v) {
            if (v instanceof Start) {
                return "\u22ca";
            };
            if (v instanceof Stop) {
                return "\u22c9";
            };
            if (v instanceof Inner) {
                return show7(v.value0);
            };
            throw new Error("Failed pattern match at ProtoVoices.Model (line 286, column 1 - line 289, column 26): " + [ v.constructor.name ]);
        }
    };
};
var showStartStop1 = /* #__PURE__ */ showStartStop(showRecord1);
var showRecord2 = /* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons(/* #__PURE__ */ showRecordFieldsConsNil(showStartStop1))(showStartStop1));
var showRecord3 = /* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "edges";
    }
})(/* #__PURE__ */ showRecordFieldsCons1(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "is2nd";
    }
})(Data_Show.showBoolean))(showTransId))(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(passingIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(regularIsSymbol)(/* #__PURE__ */ Data_Set.showSet(showRecord2)))(/* #__PURE__ */ Data_Show.showArray(showRecord2)))));
var logShow = /* #__PURE__ */ Effect_Console.logShow(showRecord3);
var showRecordFieldsConsNil2 = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "trans";
    }
})(showRecord3);
var showRecordFieldsCons7 = /* #__PURE__ */ showRecordFieldsCons5(showRecordFieldsConsNil2);
var show3 = /* #__PURE__ */ Data_Show.show(showRecord3);
var show4 = /* #__PURE__ */ Data_Show.show(showStartStop1);
var showSliceId = {
    show: function (v) {
        return "s" + show(v);
    }
};
var show5 = /* #__PURE__ */ Data_Show.show(showSliceId);
var setNoteStyle = function (id) {
    return function (style) {
        return function (model) {
            var notes$prime = insert(id)(style)(model.styles.notes);
            return {
                piece: model.piece,
                reduction: model.reduction,
                styles: {
                    edges: model.styles.edges,
                    slices: model.styles.slices,
                    transitions: model.styles.transitions,
                    css: model.styles.css,
                    staff: model.styles.staff,
                    notes: notes$prime
                }
            };
        };
    };
};
var setHoriExplParent = function (_child) {
    return function (parentMaybe) {
        return function (expl) {
            if (parentMaybe instanceof Data_Maybe.Just) {
                if (expl instanceof NoExpl) {
                    return new Data_Maybe.Just(new HoriExpl(parentMaybe.value0));
                };
                if (expl instanceof HoriExpl) {
                    return new Data_Maybe.Just(new HoriExpl(parentMaybe.value0));
                };
                return Data_Maybe.Nothing.value;
            };
            if (parentMaybe instanceof Data_Maybe.Nothing) {
                if (expl instanceof HoriExpl) {
                    return new Data_Maybe.Just(NoExpl.value);
                };
                if (expl instanceof NoExpl) {
                    return new Data_Maybe.Just(NoExpl.value);
                };
                return Data_Maybe.Nothing.value;
            };
            throw new Error("Failed pattern match at ProtoVoices.Model (line 242, column 45 - line 250, column 17): " + [ parentMaybe.constructor.name ]);
        };
    };
};
var setEdgeStyle = function (ids) {
    return function (style) {
        return function (model) {
            var edges$prime = insert1(ids)(style)(model.styles.edges);
            return {
                piece: model.piece,
                reduction: model.reduction,
                styles: {
                    notes: model.styles.notes,
                    slices: model.styles.slices,
                    transitions: model.styles.transitions,
                    css: model.styles.css,
                    staff: model.styles.staff,
                    edges: edges$prime
                }
            };
        };
    };
};
var readForeignTransId = Simple_JSON.readInt;
var readForeignStartStop = function (dictReadForeign) {
    var readImpl1 = Simple_JSON.readImpl(dictReadForeign);
    return {
        readImpl: function (frgn) {
            var tryOuter = bind(readImpl(frgn))(function (str) {
                if (str === "start") {
                    return pure(Start.value);
                };
                if (str === "stop") {
                    return pure(Stop.value);
                };
                return fail(new Foreign.ForeignError("StartStop is neither Start nor Stop!"));
            });
            return alt(tryOuter)(map1(Inner.create)(readImpl1(frgn)));
        }
    };
};
var readForeignSliceId = Simple_JSON.readInt;
var pbetween = function (dictInterval) {
    var direction1 = Data_Pitches_Class.direction(dictInterval);
    var pto1 = Data_Pitches_Class.pto(dictInterval);
    return function (dictEq) {
        var notEq1 = Data_Eq.notEq(Data_Pitches_Class.eqPitch(dictEq));
        return function (l) {
            return function (m) {
                return function (r) {
                    var odir = direction1(pto1(l)(r));
                    var dir2 = direction1(pto1(m)(r));
                    var dir1 = direction1(pto1(l)(m));
                    return notEq1(l)(m) && (notEq1(m)(r) && (notEq1(l)(r) && (eq(dir1)(odir) && eq(dir2)(odir))));
                };
            };
        };
    };
};
var ordTransId = Data_Ord.ordInt;
var insert2 = /* #__PURE__ */ Data_Map_Internal.insert(ordTransId);
var alter2 = /* #__PURE__ */ Data_Map_Internal.alter(ordTransId);
var setTransStyle = function (id) {
    return function (style) {
        return function (model) {
            var transitions$prime = insert2(id)(style)(model.styles.transitions);
            return {
                piece: model.piece,
                reduction: model.reduction,
                styles: {
                    notes: model.styles.notes,
                    edges: model.styles.edges,
                    slices: model.styles.slices,
                    css: model.styles.css,
                    staff: model.styles.staff,
                    transitions: transitions$prime
                }
            };
        };
    };
};
var stylesUpdateTrans = function (f) {
    return function (id) {
        return function (styles) {
            return {
                notes: styles.notes,
                edges: styles.edges,
                slices: styles.slices,
                css: styles.css,
                staff: styles.staff,
                transitions: alter2(f)(id)(styles.transitions)
            };
        };
    };
};
var ordSliceId = Data_Ord.ordInt;
var insert3 = /* #__PURE__ */ Data_Map_Internal.insert(ordSliceId);
var alter3 = /* #__PURE__ */ Data_Map_Internal.alter(ordSliceId);
var setSliceStyle = function (id) {
    return function (style) {
        return function (model) {
            var slices$prime = insert3(id)(style)(model.styles.slices);
            return {
                piece: model.piece,
                reduction: model.reduction,
                styles: {
                    notes: model.styles.notes,
                    edges: model.styles.edges,
                    transitions: model.styles.transitions,
                    css: model.styles.css,
                    staff: model.styles.staff,
                    slices: slices$prime
                }
            };
        };
    };
};
var stylesUpdateSlice = function (f) {
    return function (id) {
        return function (styles) {
            return {
                notes: styles.notes,
                edges: styles.edges,
                transitions: styles.transitions,
                css: styles.css,
                staff: styles.staff,
                slices: alter3(f)(id)(styles.slices)
            };
        };
    };
};
var isRepeatingEdge = function (v) {
    if (v.left instanceof Inner && v.right instanceof Inner) {
        return eq1(pc(v.left.value0.pitch))(pc(v.right.value0.pitch));
    };
    return false;
};
var incT = function (v) {
    return v + 1 | 0;
};
var incS = function (v) {
    return v + 1 | 0;
};
var getParents = function (v) {
    if (v instanceof NoParents) {
        return [  ];
    };
    if (v instanceof VertParent) {
        return [ v.value0 ];
    };
    if (v instanceof MergeParents) {
        return [ v.value0.left, v.value0.right ];
    };
    throw new Error("Failed pattern match at ProtoVoices.Model (line 385, column 14 - line 388, column 50): " + [ v.constructor.name ]);
};
var getInnerNotes = function (slice) {
    if (slice.notes instanceof Start) {
        return [  ];
    };
    if (slice.notes instanceof Stop) {
        return [  ];
    };
    if (slice.notes instanceof Inner) {
        return slice.notes.value0;
    };
    throw new Error("Failed pattern match at ProtoVoices.Model (line 398, column 23 - line 401, column 23): " + [ slice.notes.constructor.name ]);
};
var getInner = function (v) {
    if (v instanceof Inner) {
        return new Data_Maybe.Just(v.value0);
    };
    return Data_Maybe.Nothing.value;
};
var genericStaff = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return TrebleStaff.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return BassStaff.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return GrandStaff.value;
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 482, column 1 - line 482, column 48): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof TrebleStaff) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof BassStaff) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof GrandStaff) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 482, column 1 - line 482, column 48): " + [ x.constructor.name ]);
    }
};
var showStaff = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericStaff)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "TrebleStaff";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "BassStaff";
        }
    }))(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "GrandStaff";
        }
    }))))
};
var genericRightOrnament = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return RightRepeat.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return RightNeighbor.value;
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 47, column 1 - line 47, column 64): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof RightRepeat) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof RightNeighbor) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 47, column 1 - line 47, column 64): " + [ x.constructor.name ]);
    }
};
var genericShow = /* #__PURE__ */ Data_Show_Generic.genericShow(genericRightOrnament)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "RightRepeat";
    }
}))(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "RightNeighbor";
    }
})));
var showRightOrnament = {
    show: function (ro) {
        return genericShow(ro);
    }
};
var genericParents = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return NoParents.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new VertParent(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new MergeParents(x.value0.value0);
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 379, column 1 - line 379, column 56): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof NoParents) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof VertParent) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof MergeParents) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 379, column 1 - line 379, column 56): " + [ x.constructor.name ]);
    }
};
var genericShow1 = /* #__PURE__ */ Data_Show_Generic.genericShow(genericParents);
var showParents = function (dictShow) {
    var genericShow6 = genericShow1(genericShowSum(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow))(VertParentIsSymbol))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showRecord(showRecordFieldsCons(showRecordFieldsConsNil(dictShow))(dictShow))))(MergeParentsIsSymbol))));
    return {
        show: function (p) {
            return genericShow6(p);
        }
    };
};
var genericOp = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Freeze.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new Split(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new Hori(x.value0.value0);
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 422, column 1 - line 422, column 42): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Freeze) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Split) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof Hori) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 422, column 1 - line 422, column 42): " + [ x.constructor.name ]);
    }
};
var genericShow2 = /* #__PURE__ */ Data_Show_Generic.genericShow(genericOp);
var genericNoteExplanation = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return NoExpl.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return RootExpl.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new HoriExpl(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new RightExpl(x.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new LeftExpl(x.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))) {
            return new DoubleExpl(x.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 89, column 1 - line 89, column 68): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof NoExpl) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof RootExpl) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof HoriExpl) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof RightExpl) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
        };
        if (x instanceof LeftExpl) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
        };
        if (x instanceof DoubleExpl) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)))));
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 89, column 1 - line 89, column 68): " + [ x.constructor.name ]);
    }
};
var genericLeftOrnament = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return LeftRepeat.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return LeftNeighbor.value;
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 58, column 1 - line 58, column 62): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof LeftRepeat) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof LeftNeighbor) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 58, column 1 - line 58, column 62): " + [ x.constructor.name ]);
    }
};
var genericShow3 = /* #__PURE__ */ Data_Show_Generic.genericShow(genericLeftOrnament)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "LeftRepeat";
    }
}))(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "LeftNeighbor";
    }
})));
var showLeftOrnament = {
    show: function (lo) {
        return genericShow3(lo);
    }
};
var genericDoubleOrnament = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return FullNeighbor.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return FullRepeat.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return LeftRepeatOfRight.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return RightRepeatOfLeft.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return PassingMid.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return PassingLeft.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))) {
            return PassingRight.value;
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 74, column 1 - line 74, column 66): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof FullNeighbor) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof FullRepeat) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof LeftRepeatOfRight) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof RightRepeatOfLeft) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof PassingMid) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
        };
        if (x instanceof PassingLeft) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
        };
        if (x instanceof PassingRight) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))))));
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 74, column 1 - line 74, column 66): " + [ x.constructor.name ]);
    }
};
var genericShow4 = /* #__PURE__ */ Data_Show_Generic.genericShow(genericDoubleOrnament)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "FullNeighbor";
    }
}))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "FullRepeat";
    }
}))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "LeftRepeatOfRight";
    }
}))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "RightRepeatOfLeft";
    }
}))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "PassingMid";
    }
}))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "PassingLeft";
    }
}))(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "PassingRight";
    }
}))))))));
var showDoubleOrnament = {
    show: function (o) {
        return genericShow4(o);
    }
};
var genericShow5 = /* #__PURE__ */ Data_Show_Generic.genericShow(genericNoteExplanation)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "NoExpl";
    }
}))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "RootExpl";
    }
}))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showRecord1))({
    reflectSymbol: function () {
        return "HoriExpl";
    }
}))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons2(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(ornIsSymbol)(/* #__PURE__ */ Data_Maybe.showMaybe(showRightOrnament)))(showRecord1))))({
    reflectSymbol: function () {
        return "RightExpl";
    }
}))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons3(/* #__PURE__ */ Data_Maybe.showMaybe(showLeftOrnament)))))({
    reflectSymbol: function () {
        return "LeftExpl";
    }
}))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons2(/* #__PURE__ */ showRecordFieldsCons3(/* #__PURE__ */ Data_Maybe.showMaybe(showDoubleOrnament)))(showRecord1))))({
    reflectSymbol: function () {
        return "DoubleExpl";
    }
})))))));
var showNoteExplanation = {
    show: function (o) {
        return genericShow5(o);
    }
};
var showRecord4 = /* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons1(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "notes";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "parents";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "x";
    }
})(Data_Show.showNumber))(/* #__PURE__ */ showParents(showSliceId)))(/* #__PURE__ */ showStartStop(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(explIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(noteIsSymbol)(showRecord1))(showNoteExplanation))))))(showSliceId));
var logShow1 = /* #__PURE__ */ Effect_Console.logShow(showRecord4);
var showRecordFieldsCons8 = /* #__PURE__ */ showRecordFieldsCons5(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "rslice";
    }
})(showRecordFieldsConsNil2)(showRecord4));
var show6 = /* #__PURE__ */ Data_Show.show(showRecord4);
var printSurface = function (model) {
    return function __do() {
        Effect_Console.log("\u22ca")();
        return for_(model.reduction.segments)(function (seg) {
            return function __do() {
                logShow(seg.trans)();
                return logShow1(seg.rslice)();
            };
        })();
    };
};
var showOp = {
    show: function (x) {
        return genericShow2(genericShowSum1(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showRecord(showRecordFieldsCons4(showRecordFieldsConsNil1(showRecord(showRecordFieldsCons7(showOp))))(showRecord(showRecordFieldsCons8(showOp))))))(SplitIsSymbol))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showRecord(showRecordFieldsCons4(showRecordFieldsCons6(showRecordFieldsConsNil1(showRecord(showRecordFieldsCons7(showOp))))(showRecord(showRecordFieldsCons8(showOp))))(showRecord(showRecordFieldsCons8(showOp))))))(HoriIsSymbol))))(x);
    }
};
var showReduction = function (v) {
    var showSegment$prime = function (indent) {
        return function (v1) {
            return power(" ")(indent) + ("trans: " + (show3(v1.trans) + (", op:" + showChildren(indent)(v1.op))));
        };
    };
    var showSegment = function (indent) {
        return function (v1) {
            return power(" ")(indent) + ("trans: " + (show3(v1.trans) + (", rslice: " + (show6(v1.rslice) + (", op:" + showChildren(indent)(v1.op))))));
        };
    };
    var showChildren = function (indent) {
        return function (v1) {
            if (v1 instanceof Freeze) {
                return "Freeze";
            };
            if (v1 instanceof Split) {
                return "Split\x0a" + (showSegment(indent + 1 | 0)(v1.value0.childl) + ("\x0a" + showSegment$prime(indent + 1 | 0)(v1.value0.childr)));
            };
            if (v1 instanceof Hori) {
                return "Hori\x0a" + (showSegment(indent + 1 | 0)(v1.value0.childl) + ("\x0a" + (showSegment(indent + 1 | 0)(v1.value0.childm) + ("\x0a" + showSegment$prime(indent + 1 | 0)(v1.value0.childr)))));
            };
            throw new Error("Failed pattern match at ProtoVoices.Model (line 545, column 25 - line 558, column 44): " + [ v1.constructor.name ]);
        };
    };
    return intercalate("\x0a")(map2(showSegment(0))(v.segments));
};
var functorStartStop = {
    map: function (f) {
        return function (m) {
            if (m instanceof Start) {
                return Start.value;
            };
            if (m instanceof Inner) {
                return new Inner(f(m.value0));
            };
            if (m instanceof Stop) {
                return Stop.value;
            };
            throw new Error("Failed pattern match at ProtoVoices.Model (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
        };
    }
};
var map5 = /* #__PURE__ */ Data_Functor.map(functorStartStop);
var resetExpls = function (seg) {
    return {
        trans: seg.trans,
        op: seg.op,
        rslice: {
            id: seg.rslice.id,
            x: seg.rslice.x,
            parents: seg.rslice.parents,
            notes: map5(map(function (note) {
                return {
                    note: note.note,
                    expl: NoExpl.value
                };
            }))(seg.rslice.notes)
        }
    };
};
var findRightOrn = function (child) {
    return function (v) {
        if (eq1(pc(child))(pc(v.pitch))) {
            return new Data_Maybe.Just(RightRepeat.value);
        };
        if (isStep(ic(pto(child)(v.pitch)))) {
            return new Data_Maybe.Just(RightNeighbor.value);
        };
        if (Data_Boolean.otherwise) {
            return Data_Maybe.Nothing.value;
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 152, column 1 - line 152, column 54): " + [ child.constructor.name, v.constructor.name ]);
    };
};
var findLeftOrn = function (child) {
    return function (v) {
        if (eq1(pc(child))(pc(v.pitch))) {
            return new Data_Maybe.Just(LeftRepeat.value);
        };
        if (isStep(ic(pto(child)(v.pitch)))) {
            return new Data_Maybe.Just(LeftNeighbor.value);
        };
        if (Data_Boolean.otherwise) {
            return Data_Maybe.Nothing.value;
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 146, column 1 - line 146, column 52): " + [ child.constructor.name, v.constructor.name ]);
    };
};
var findDoubleOrn = function (child) {
    return function (v) {
        return function (v1) {
            var v2 = function (v3) {
                var v4 = function (v5) {
                    var v6 = function (v7) {
                        var v8 = function (v9) {
                            var v10 = function (v11) {
                                var v12 = function (v13) {
                                    if (Data_Boolean.otherwise) {
                                        var $826 = isStep(ic(pto(child)(v.pitch)));
                                        if ($826) {
                                            var $827 = isStep(ic(pto(child)(v1.pitch)));
                                            if ($827) {
                                                return new Data_Maybe.Just(PassingMid.value);
                                            };
                                            return new Data_Maybe.Just(PassingLeft.value);
                                        };
                                        var $828 = isStep(ic(pto(child)(v1.pitch)));
                                        if ($828) {
                                            return new Data_Maybe.Just(PassingRight.value);
                                        };
                                        return Data_Maybe.Nothing.value;
                                    };
                                    throw new Error("Failed pattern match at ProtoVoices.Model (line 167, column 1 - line 167, column 64): " + [ child.constructor.name, v.constructor.name, v1.constructor.name ]);
                                };
                                var $834 = degree(pc(v.pitch)) === degree(pc(v1.pitch));
                                if ($834) {
                                    var $835 = isStep(ic(pto(child)(v.pitch)));
                                    if ($835) {
                                        return new Data_Maybe.Just(FullNeighbor.value);
                                    };
                                    return v12(true);
                                };
                                return v12(true);
                            };
                            var $841 = degree(pc(child)) === degree(pc(v1.pitch));
                            if ($841) {
                                var $842 = ic(pto(v.pitch)(child));
                                var $843 = ic(pto(child)(v1.pitch));
                                var $844 = isStep($842);
                                if ($844) {
                                    var $845 = notEq(direction($842))(compare1($843)(unison));
                                    if ($845) {
                                        return new Data_Maybe.Just(LeftRepeatOfRight.value);
                                    };
                                    return v10(true);
                                };
                                return v10(true);
                            };
                            return v10(true);
                        };
                        var $851 = degree(pc(child)) === degree(pc(v.pitch));
                        if ($851) {
                            var $852 = ic(pto(v.pitch)(child));
                            var $853 = ic(pto(child)(v1.pitch));
                            var $854 = isStep($853);
                            if ($854) {
                                var $855 = notEq(compare1($852)(unison))(direction($853));
                                if ($855) {
                                    return new Data_Maybe.Just(RightRepeatOfLeft.value);
                                };
                                return v8(true);
                            };
                            return v8(true);
                        };
                        return v8(true);
                    };
                    var $861 = eq1(pc(child))(pc(v1.pitch));
                    if ($861) {
                        var $862 = isStep(ic(pto(child)(v.pitch)));
                        if ($862) {
                            return new Data_Maybe.Just(LeftRepeatOfRight.value);
                        };
                        return v6(true);
                    };
                    return v6(true);
                };
                var $868 = eq1(pc(child))(pc(v.pitch));
                if ($868) {
                    var $869 = isStep(ic(pto(child)(v1.pitch)));
                    if ($869) {
                        return new Data_Maybe.Just(RightRepeatOfLeft.value);
                    };
                    return v4(true);
                };
                return v4(true);
            };
            var $875 = eq1(pc(child))(pc(v.pitch));
            if ($875) {
                var $876 = eq1(pc(child))(pc(v1.pitch));
                if ($876) {
                    return new Data_Maybe.Just(FullRepeat.value);
                };
                return v2(true);
            };
            return v2(true);
        };
    };
};
var setLeftExplParent = function (child) {
    return function (leftParentMaybe) {
        return function (expl) {
            if (leftParentMaybe instanceof Data_Maybe.Just) {
                if (expl instanceof NoExpl) {
                    return new Data_Maybe.Just(new RightExpl({
                        orn: findRightOrn(child)(leftParentMaybe.value0),
                        leftParent: leftParentMaybe.value0
                    }));
                };
                if (expl instanceof RightExpl) {
                    return new Data_Maybe.Just(new RightExpl({
                        orn: findRightOrn(child)(leftParentMaybe.value0),
                        leftParent: leftParentMaybe.value0
                    }));
                };
                if (expl instanceof LeftExpl) {
                    return new Data_Maybe.Just(new DoubleExpl({
                        orn: findDoubleOrn(child)(leftParentMaybe.value0)(expl.value0.rightParent),
                        leftParent: leftParentMaybe.value0,
                        rightParent: expl.value0.rightParent
                    }));
                };
                if (expl instanceof DoubleExpl) {
                    return new Data_Maybe.Just(new DoubleExpl({
                        orn: findDoubleOrn(child)(leftParentMaybe.value0)(expl.value0.rightParent),
                        leftParent: leftParentMaybe.value0,
                        rightParent: expl.value0.rightParent
                    }));
                };
                return Data_Maybe.Nothing.value;
            };
            if (leftParentMaybe instanceof Data_Maybe.Nothing) {
                if (expl instanceof LeftExpl) {
                    return new Data_Maybe.Just(new LeftExpl(expl.value0));
                };
                if (expl instanceof DoubleExpl) {
                    return new Data_Maybe.Just(new LeftExpl({
                        orn: findLeftOrn(child)(expl.value0.rightParent),
                        rightParent: expl.value0.rightParent
                    }));
                };
                if (expl instanceof HoriExpl) {
                    return Data_Maybe.Nothing.value;
                };
                return new Data_Maybe.Just(NoExpl.value);
            };
            throw new Error("Failed pattern match at ProtoVoices.Model (line 190, column 48 - line 213, column 21): " + [ leftParentMaybe.constructor.name ]);
        };
    };
};
var setRightExplParent = function (child) {
    return function (rightParentMaybe) {
        return function (expl) {
            if (rightParentMaybe instanceof Data_Maybe.Just) {
                if (expl instanceof NoExpl) {
                    return new Data_Maybe.Just(new LeftExpl({
                        orn: findLeftOrn(child)(rightParentMaybe.value0),
                        rightParent: rightParentMaybe.value0
                    }));
                };
                if (expl instanceof LeftExpl) {
                    return new Data_Maybe.Just(new LeftExpl({
                        orn: findLeftOrn(child)(rightParentMaybe.value0),
                        rightParent: rightParentMaybe.value0
                    }));
                };
                if (expl instanceof RightExpl) {
                    return new Data_Maybe.Just(new DoubleExpl({
                        orn: findDoubleOrn(child)(expl.value0.leftParent)(rightParentMaybe.value0),
                        leftParent: expl.value0.leftParent,
                        rightParent: rightParentMaybe.value0
                    }));
                };
                if (expl instanceof DoubleExpl) {
                    return new Data_Maybe.Just(new DoubleExpl({
                        orn: findDoubleOrn(child)(expl.value0.leftParent)(rightParentMaybe.value0),
                        leftParent: expl.value0.leftParent,
                        rightParent: rightParentMaybe.value0
                    }));
                };
                return Data_Maybe.Nothing.value;
            };
            if (rightParentMaybe instanceof Data_Maybe.Nothing) {
                if (expl instanceof RightExpl) {
                    return new Data_Maybe.Just(new RightExpl(expl.value0));
                };
                if (expl instanceof DoubleExpl) {
                    return new Data_Maybe.Just(new RightExpl({
                        orn: findRightOrn(child)(expl.value0.leftParent),
                        leftParent: expl.value0.leftParent
                    }));
                };
                if (expl instanceof HoriExpl) {
                    return Data_Maybe.Nothing.value;
                };
                return new Data_Maybe.Just(NoExpl.value);
            };
            throw new Error("Failed pattern match at ProtoVoices.Model (line 216, column 50 - line 239, column 21): " + [ rightParentMaybe.constructor.name ]);
        };
    };
};
var explParents = function (v) {
    if (v instanceof NoExpl) {
        return [  ];
    };
    if (v instanceof RootExpl) {
        return [  ];
    };
    if (v instanceof HoriExpl) {
        return [ v.value0 ];
    };
    if (v instanceof RightExpl) {
        return [ v.value0.leftParent ];
    };
    if (v instanceof LeftExpl) {
        return [ v.value0.rightParent ];
    };
    if (v instanceof DoubleExpl) {
        return [ v.value0.leftParent, v.value0.rightParent ];
    };
    throw new Error("Failed pattern match at ProtoVoices.Model (line 262, column 15 - line 268, column 72): " + [ v.constructor.name ]);
};
var explIsSplit = function (v) {
    if (v instanceof HoriExpl) {
        return false;
    };
    return true;
};
var explIsHori = function (v) {
    if (v instanceof NoExpl) {
        return true;
    };
    if (v instanceof HoriExpl) {
        return true;
    };
    return false;
};
var explHasParent = function (id) {
    return function (v) {
        if (v instanceof NoExpl) {
            return false;
        };
        if (v instanceof RootExpl) {
            return false;
        };
        if (v instanceof HoriExpl) {
            return v.value0.id === id;
        };
        if (v instanceof RightExpl) {
            return v.value0.leftParent.id === id;
        };
        if (v instanceof LeftExpl) {
            return v.value0.rightParent.id === id;
        };
        if (v instanceof DoubleExpl) {
            return v.value0.leftParent.id === id || v.value0.rightParent.id === id;
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 253, column 20 - line 259, column 88): " + [ v.constructor.name ]);
    };
};
var eqTransId = Data_Eq.eqInt;
var eq7 = /* #__PURE__ */ Data_Eq.eq(eqTransId);
var eqStartStop = function (dictEq) {
    var eq17 = Data_Eq.eq(dictEq);
    return {
        eq: function (x) {
            return function (y) {
                if (x instanceof Start && y instanceof Start) {
                    return true;
                };
                if (x instanceof Inner && y instanceof Inner) {
                    return eq17(x.value0)(y.value0);
                };
                if (x instanceof Stop && y instanceof Stop) {
                    return true;
                };
                return false;
            };
        }
    };
};
var eqStartStop1 = /* #__PURE__ */ eqStartStop(eqRec1);
var eqRec2 = /* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons(rightIsSymbol)(eqStartStop1))()(leftIsSymbol)(eqStartStop1));
var eq8 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Eq.eqArray(eqRec2));
var eq9 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Set.eqSet(eqRec2));
var ordStartStop = function (dictOrd) {
    var compare2 = Data_Ord.compare(dictOrd);
    var eqStartStop2 = eqStartStop(dictOrd.Eq0());
    return {
        compare: function (x) {
            return function (y) {
                if (x instanceof Start && y instanceof Start) {
                    return Data_Ordering.EQ.value;
                };
                if (x instanceof Start) {
                    return Data_Ordering.LT.value;
                };
                if (y instanceof Start) {
                    return Data_Ordering.GT.value;
                };
                if (x instanceof Inner && y instanceof Inner) {
                    return compare2(x.value0)(y.value0);
                };
                if (x instanceof Inner) {
                    return Data_Ordering.LT.value;
                };
                if (y instanceof Inner) {
                    return Data_Ordering.GT.value;
                };
                if (x instanceof Stop && y instanceof Stop) {
                    return Data_Ordering.EQ.value;
                };
                throw new Error("Failed pattern match at ProtoVoices.Model (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
            };
        },
        Eq0: function () {
            return eqStartStop2;
        }
    };
};
var ordStartStop1 = /* #__PURE__ */ ordStartStop(/* #__PURE__ */ ordRecord(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ ordRecordCons(pitchIsSymbol)(ordPitch))()(idIsSymbol)(Data_Ord.ordString)));
var ordRecord1 = /* #__PURE__ */ ordRecord(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ ordRecordCons(rightIsSymbol)(ordStartStop1))()(leftIsSymbol)(ordStartStop1));
var catMaybes = /* #__PURE__ */ Data_Set.catMaybes(ordRecord1);
var map6 = /* #__PURE__ */ Data_Set.map(/* #__PURE__ */ Data_Maybe.ordMaybe(ordRecord1));
var fromFoldable1 = /* #__PURE__ */ Data_Set.fromFoldable(Data_Foldable.foldableArray)(ordRecord1);
var monoidRecord = /* #__PURE__ */ Data_Monoid.monoidRecord()(/* #__PURE__ */ Data_Monoid.monoidRecordCons(passingIsSymbol)(Data_Monoid.monoidArray)()(/* #__PURE__ */ Data_Monoid.monoidRecordCons(regularIsSymbol)(/* #__PURE__ */ Data_Set.monoidSet(ordRecord1))()(Data_Monoid.monoidRecordNil)));
var insert4 = /* #__PURE__ */ Data_Set.insert(ordRecord1);
var append3 = /* #__PURE__ */ Data_Semigroup.append(/* #__PURE__ */ Data_Semigroup.semigroupRecord()(/* #__PURE__ */ Data_Semigroup.semigroupRecordCons(passingIsSymbol)()(/* #__PURE__ */ Data_Semigroup.semigroupRecordCons(regularIsSymbol)()(Data_Semigroup.semigroupRecordNil)(/* #__PURE__ */ Data_Set.semigroupSet(ordRecord1)))(Data_Semigroup.semigroupArray)));
var foldMap = /* #__PURE__ */ Data_Foldable.foldMap(Data_Foldable.foldableArray)(monoidRecord);
var horiEdgesLeft = function (edgesl) {
    return function (slicel) {
        var v = function (v1) {
            if (Data_Boolean.otherwise) {
                return edgesl;
            };
            throw new Error("Failed pattern match at ProtoVoices.Model (line 777, column 1 - line 777, column 41): " + [ edgesl.constructor.name, slicel.constructor.name ]);
        };
        if (slicel.notes instanceof Inner) {
            var replaceRight = function (v1) {
                var v2 = function (v3) {
                    if (Data_Boolean.otherwise) {
                        return Data_Maybe.Nothing.value;
                    };
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 777, column 1 - line 777, column 41): " + [ v1.constructor.name ]);
                };
                if (v1.right instanceof Inner) {
                    var $949 = Data_Array.find(function (n) {
                        if (n.expl instanceof HoriExpl) {
                            return n.expl.value0.id === v1.right.value0.id;
                        };
                        return false;
                    })(slicel.notes.value0);
                    if ($949 instanceof Data_Maybe.Just) {
                        return new Data_Maybe.Just({
                            left: v1.left,
                            right: new Inner($949.value0.note)
                        });
                    };
                    return v2(true);
                };
                return v2(true);
            };
            return {
                regular: catMaybes(map6(replaceRight)(edgesl.regular)),
                passing: Data_Array.catMaybes(map(replaceRight)(edgesl.passing))
            };
        };
        return v(true);
    };
};
var horiEdgesRight = function (slicer) {
    return function (edgesr) {
        var v = function (v1) {
            if (Data_Boolean.otherwise) {
                return edgesr;
            };
            throw new Error("Failed pattern match at ProtoVoices.Model (line 798, column 1 - line 798, column 42): " + [ slicer.constructor.name, edgesr.constructor.name ]);
        };
        if (slicer.notes instanceof Inner) {
            var replaceLeft = function (v1) {
                var v2 = function (v3) {
                    if (Data_Boolean.otherwise) {
                        return Data_Maybe.Nothing.value;
                    };
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 798, column 1 - line 798, column 42): " + [ v1.constructor.name ]);
                };
                if (v1.left instanceof Inner) {
                    var $967 = Data_Array.find(function (n) {
                        if (n.expl instanceof HoriExpl) {
                            return n.expl.value0.id === v1.left.value0.id;
                        };
                        return false;
                    })(slicer.notes.value0);
                    if ($967 instanceof Data_Maybe.Just) {
                        return new Data_Maybe.Just({
                            left: new Inner($967.value0.note),
                            right: v1.right
                        });
                    };
                    return v2(true);
                };
                return v2(true);
            };
            return {
                regular: catMaybes(map6(replaceLeft)(edgesr.regular)),
                passing: Data_Array.catMaybes(map(replaceLeft)(edgesr.passing))
            };
        };
        return v(true);
    };
};
var thawTrans = function (ties) {
    return function (id) {
        return function (slice) {
            return {
                id: id,
                is2nd: false,
                edges: {
                    regular: fromFoldable1(ties),
                    passing: [  ]
                }
            };
        };
    };
};
var thawPiece = function (piece) {
    var thaw = function (st) {
        return function (v) {
            var seg = new Data_Maybe.Just({
                trans: thawTrans(st.ties)(st.i)(v.notes),
                rslice: thawSlice(v.notes)(st.i + 1 | 0),
                op: Freeze.value
            });
            var mkTie = function (note) {
                if (note.hold instanceof Data_Maybe.Nothing) {
                    return Data_Maybe.Nothing.value;
                };
                if (note.hold instanceof Data_Maybe.Just) {
                    return new Data_Maybe.Just({
                        left: new Inner(note.note),
                        right: new Inner({
                            pitch: note.note.pitch,
                            id: note.hold.value0
                        })
                    });
                };
                throw new Error("Failed pattern match at ProtoVoices.Model (line 624, column 18 - line 626, column 84): " + [ note.hold.constructor.name ]);
            };
            var tiesNext = Data_Array.mapMaybe(mkTie)(v.notes);
            return {
                seg: seg,
                ties: tiesNext,
                i: st.i + 1 | 0
            };
        };
    };
    var init = {
        seg: Data_Maybe.Nothing.value,
        ties: [  ],
        i: 0
    };
    var states = scanl(thaw)(init)(piece);
    var imax = Data_Maybe.maybe(0)(function (v) {
        return v.i;
    })(Data_Array.last(states));
    var lastSeg = {
        trans: thawTrans([  ])(imax)([  ]),
        rslice: {
            id: imax + 1 | 0,
            notes: Stop.value,
            x: Data_Int.toNumber(imax + 1 | 0),
            parents: NoParents.value
        },
        op: Freeze.value
    };
    var segs = append(Data_Array.catMaybes(map(function (v) {
        return v.seg;
    })(states)))([ lastSeg ]);
    return {
        start: startSlice,
        segments: fromFoldable(segs),
        nextSliceId: imax + 2 | 0,
        nextTransId: imax + 1 | 0
    };
};
var vertEdgesLeft = function (edges) {
    return function (slice) {
        var v = function (v1) {
            if (Data_Boolean.otherwise) {
                return new Data_Either.Left("The current reduction is invalid: Trying to vert a Start or Stop slice.");
            };
            throw new Error("Failed pattern match at ProtoVoices.Model (line 741, column 1 - line 741, column 55): " + [ edges.constructor.name, slice.constructor.name ]);
        };
        if (slice.notes instanceof Inner) {
            var replaceRight = function (v1) {
                var v2 = function (v3) {
                    if (Data_Boolean.otherwise) {
                        return Data_Maybe.Nothing.value;
                    };
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 741, column 1 - line 741, column 55): " + [ v1.constructor.name ]);
                };
                if (v1.right instanceof Inner) {
                    var $988 = Data_Array.find(function (n) {
                        return n.note.id === v1.right.value0.id;
                    })(slice.notes.value0);
                    if ($988 instanceof Data_Maybe.Just) {
                        if ($988.value0.expl instanceof HoriExpl) {
                            return new Data_Maybe.Just({
                                left: v1.left,
                                right: new Inner($988.value0.expl.value0)
                            });
                        };
                        return v2(true);
                    };
                    return v2(true);
                };
                return v2(true);
            };
            return new Data_Either.Right({
                regular: catMaybes(map6(replaceRight)(edges.regular)),
                passing: Data_Array.catMaybes(map(replaceRight)(edges.passing))
            });
        };
        return v(true);
    };
};
var vertEdgesRight = function (edges) {
    return function (slice) {
        var v = function (v1) {
            if (Data_Boolean.otherwise) {
                return new Data_Either.Left("The current reduction is invalid: Trying to vert a Start or Stop slice.");
            };
            throw new Error("Failed pattern match at ProtoVoices.Model (line 759, column 1 - line 759, column 56): " + [ edges.constructor.name, slice.constructor.name ]);
        };
        if (slice.notes instanceof Inner) {
            var replaceLeft = function (v1) {
                var v2 = function (v3) {
                    if (Data_Boolean.otherwise) {
                        return Data_Maybe.Nothing.value;
                    };
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 759, column 1 - line 759, column 56): " + [ v1.constructor.name ]);
                };
                if (v1.left instanceof Inner) {
                    var $1006 = Data_Array.find(function (n) {
                        return n.note.id === v1.left.value0.id;
                    })(slice.notes.value0);
                    if ($1006 instanceof Data_Maybe.Just) {
                        if ($1006.value0.expl instanceof HoriExpl) {
                            return new Data_Maybe.Just({
                                left: new Inner($1006.value0.expl.value0),
                                right: v1.right
                            });
                        };
                        return v2(true);
                    };
                    return v2(true);
                };
                return v2(true);
            };
            return new Data_Either.Right({
                regular: catMaybes(map6(replaceLeft)(edges.regular)),
                passing: Data_Array.catMaybes(map(replaceLeft)(edges.passing))
            });
        };
        return v(true);
    };
};
var eqStaff = {
    eq: function (x) {
        return function (y) {
            if (x instanceof TrebleStaff && y instanceof TrebleStaff) {
                return true;
            };
            if (x instanceof BassStaff && y instanceof BassStaff) {
                return true;
            };
            if (x instanceof GrandStaff && y instanceof GrandStaff) {
                return true;
            };
            return false;
        };
    }
};
var eqSliceId = Data_Eq.eqInt;
var eq10 = /* #__PURE__ */ Data_Eq.eq(eqSliceId);
var eqRightOrnament = {
    eq: function (x) {
        return function (y) {
            if (x instanceof RightRepeat && y instanceof RightRepeat) {
                return true;
            };
            if (x instanceof RightNeighbor && y instanceof RightNeighbor) {
                return true;
            };
            return false;
        };
    }
};
var eq11 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(eqRightOrnament));
var eqParents = function (dictEq) {
    var eq17 = Data_Eq.eq(dictEq);
    return {
        eq: function (x) {
            return function (y) {
                if (x instanceof NoParents && y instanceof NoParents) {
                    return true;
                };
                if (x instanceof VertParent && y instanceof VertParent) {
                    return eq17(x.value0)(y.value0);
                };
                if (x instanceof MergeParents && y instanceof MergeParents) {
                    return eq17(x.value0.left)(y.value0.left) && eq17(x.value0.right)(y.value0.right);
                };
                return false;
            };
        }
    };
};
var eq12 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ eqParents(eqSliceId));
var eqLeftOrnament = {
    eq: function (x) {
        return function (y) {
            if (x instanceof LeftRepeat && y instanceof LeftRepeat) {
                return true;
            };
            if (x instanceof LeftNeighbor && y instanceof LeftNeighbor) {
                return true;
            };
            return false;
        };
    }
};
var eq13 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(eqLeftOrnament));
var eqDoubleOrnament = {
    eq: function (x) {
        return function (y) {
            if (x instanceof FullNeighbor && y instanceof FullNeighbor) {
                return true;
            };
            if (x instanceof FullRepeat && y instanceof FullRepeat) {
                return true;
            };
            if (x instanceof LeftRepeatOfRight && y instanceof LeftRepeatOfRight) {
                return true;
            };
            if (x instanceof RightRepeatOfLeft && y instanceof RightRepeatOfLeft) {
                return true;
            };
            if (x instanceof PassingMid && y instanceof PassingMid) {
                return true;
            };
            if (x instanceof PassingLeft && y instanceof PassingLeft) {
                return true;
            };
            if (x instanceof PassingRight && y instanceof PassingRight) {
                return true;
            };
            return false;
        };
    }
};
var eq14 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(eqDoubleOrnament));
var eqNoteExplanation = {
    eq: function (x) {
        return function (y) {
            if (x instanceof NoExpl && y instanceof NoExpl) {
                return true;
            };
            if (x instanceof RootExpl && y instanceof RootExpl) {
                return true;
            };
            if (x instanceof HoriExpl && y instanceof HoriExpl) {
                return x.value0.id === y.value0.id && eq4(x.value0.pitch)(y.value0.pitch);
            };
            if (x instanceof RightExpl && y instanceof RightExpl) {
                return x.value0.leftParent.id === y.value0.leftParent.id && eq4(x.value0.leftParent.pitch)(y.value0.leftParent.pitch) && eq11(x.value0.orn)(y.value0.orn);
            };
            if (x instanceof LeftExpl && y instanceof LeftExpl) {
                return eq13(x.value0.orn)(y.value0.orn) && (x.value0.rightParent.id === y.value0.rightParent.id && eq4(x.value0.rightParent.pitch)(y.value0.rightParent.pitch));
            };
            if (x instanceof DoubleExpl && y instanceof DoubleExpl) {
                return x.value0.leftParent.id === y.value0.leftParent.id && eq4(x.value0.leftParent.pitch)(y.value0.leftParent.pitch) && eq14(x.value0.orn)(y.value0.orn) && (x.value0.rightParent.id === y.value0.rightParent.id && eq4(x.value0.rightParent.pitch)(y.value0.rightParent.pitch));
            };
            return false;
        };
    }
};
var eq15 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ eqStartStop(/* #__PURE__ */ Data_Eq.eqArray(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons(noteIsSymbol)(eqRec1))()(explIsSymbol)(eqNoteExplanation)))));
var eqOp = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Freeze && y instanceof Freeze) {
                return true;
            };
            if (x instanceof Split && y instanceof Split) {
                return Data_Eq.eq(eqOp)(x.value0.childl.op)(y.value0.childl.op) && (eq10(x.value0.childl.rslice.id)(y.value0.childl.rslice.id) && eq15(x.value0.childl.rslice.notes)(y.value0.childl.rslice.notes) && eq12(x.value0.childl.rslice.parents)(y.value0.childl.rslice.parents) && x.value0.childl.rslice.x === y.value0.childl.rslice.x) && (eq8(x.value0.childl.trans.edges.passing)(y.value0.childl.trans.edges.passing) && eq9(x.value0.childl.trans.edges.regular)(y.value0.childl.trans.edges.regular) && eq7(x.value0.childl.trans.id)(y.value0.childl.trans.id) && x.value0.childl.trans.is2nd === y.value0.childl.trans.is2nd) && (Data_Eq.eq(eqOp)(x.value0.childr.op)(y.value0.childr.op) && (eq8(x.value0.childr.trans.edges.passing)(y.value0.childr.trans.edges.passing) && eq9(x.value0.childr.trans.edges.regular)(y.value0.childr.trans.edges.regular) && eq7(x.value0.childr.trans.id)(y.value0.childr.trans.id) && x.value0.childr.trans.is2nd === y.value0.childr.trans.is2nd));
            };
            if (x instanceof Hori && y instanceof Hori) {
                return Data_Eq.eq(eqOp)(x.value0.childl.op)(y.value0.childl.op) && (eq10(x.value0.childl.rslice.id)(y.value0.childl.rslice.id) && eq15(x.value0.childl.rslice.notes)(y.value0.childl.rslice.notes) && eq12(x.value0.childl.rslice.parents)(y.value0.childl.rslice.parents) && x.value0.childl.rslice.x === y.value0.childl.rslice.x) && (eq8(x.value0.childl.trans.edges.passing)(y.value0.childl.trans.edges.passing) && eq9(x.value0.childl.trans.edges.regular)(y.value0.childl.trans.edges.regular) && eq7(x.value0.childl.trans.id)(y.value0.childl.trans.id) && x.value0.childl.trans.is2nd === y.value0.childl.trans.is2nd) && (Data_Eq.eq(eqOp)(x.value0.childm.op)(y.value0.childm.op) && (eq10(x.value0.childm.rslice.id)(y.value0.childm.rslice.id) && eq15(x.value0.childm.rslice.notes)(y.value0.childm.rslice.notes) && eq12(x.value0.childm.rslice.parents)(y.value0.childm.rslice.parents) && x.value0.childm.rslice.x === y.value0.childm.rslice.x) && (eq8(x.value0.childm.trans.edges.passing)(y.value0.childm.trans.edges.passing) && eq9(x.value0.childm.trans.edges.regular)(y.value0.childm.trans.edges.regular) && eq7(x.value0.childm.trans.id)(y.value0.childm.trans.id) && x.value0.childm.trans.is2nd === y.value0.childm.trans.is2nd)) && (Data_Eq.eq(eqOp)(x.value0.childr.op)(y.value0.childr.op) && (eq8(x.value0.childr.trans.edges.passing)(y.value0.childr.trans.edges.passing) && eq9(x.value0.childr.trans.edges.regular)(y.value0.childr.trans.edges.regular) && eq7(x.value0.childr.trans.id)(y.value0.childr.trans.id) && x.value0.childr.trans.is2nd === y.value0.childr.trans.is2nd));
            };
            return false;
        };
    }
};
var eq16 = /* #__PURE__ */ Data_Eq.eq(eqOp);
var setParents = function (p) {
    return function (seg) {
        var findUniqueVertExpl = function (parentSlice) {
            return function (child) {
                var v = Data_Array.filter(function (pnote) {
                    return eq4(pnote.note.pitch)(child.note.pitch);
                })(getInnerNotes(parentSlice));
                if (v.length === 1) {
                    return {
                        note: child.note,
                        expl: new HoriExpl(v[0].note)
                    };
                };
                return child;
            };
        };
        var findUniqueMergeExpl = function (leftSlice) {
            return function (rightSlice) {
                return function (child) {
                    var v = function (v1) {
                        var v2 = function (v3) {
                            if (Data_Boolean.otherwise) {
                                return child;
                            };
                            throw new Error("Failed pattern match at ProtoVoices.Model (line 681, column 1 - line 681, column 50): " + [ leftSlice.constructor.name, rightSlice.constructor.name, child.constructor.name ]);
                        };
                        if (leftSlice.notes instanceof Inner) {
                            if (rightSlice.notes instanceof Inner) {
                                var rightExpls = Data_Array.catMaybes(bind1(leftSlice.notes.value0)(function (v3) {
                                    return pure1(bind2(findRightOrn(child.note.pitch)(v3.note))(function (orn) {
                                        return pure2(new RightExpl({
                                            orn: new Data_Maybe.Just(orn),
                                            leftParent: v3.note
                                        }));
                                    }));
                                }));
                                var leftExpls = Data_Array.catMaybes(bind1(rightSlice.notes.value0)(function (v3) {
                                    return pure1(bind2(findLeftOrn(child.note.pitch)(v3.note))(function (orn) {
                                        return pure2(new LeftExpl({
                                            orn: new Data_Maybe.Just(orn),
                                            rightParent: v3.note
                                        }));
                                    }));
                                }));
                                var doubleExpls = Data_Array.catMaybes(bind1(leftSlice.notes.value0)(function (v3) {
                                    return bind1(rightSlice.notes.value0)(function (v4) {
                                        return pure1(bind2(findDoubleOrn(child.note.pitch)(v3.note)(v4.note))(function (orn) {
                                            return pure2(new DoubleExpl({
                                                orn: new Data_Maybe.Just(orn),
                                                leftParent: v3.note,
                                                rightParent: v4.note
                                            }));
                                        }));
                                    });
                                }));
                                if (doubleExpls.length === 1) {
                                    return {
                                        note: child.note,
                                        expl: doubleExpls[0]
                                    };
                                };
                                var v3 = append(leftExpls)(rightExpls);
                                if (v3.length === 1) {
                                    return {
                                        note: child.note,
                                        expl: v3[0]
                                    };
                                };
                                return child;
                            };
                            return v2(true);
                        };
                        return v2(true);
                    };
                    var $1071 = eq15(leftSlice.notes)(Start.value);
                    if ($1071) {
                        var $1072 = eq15(rightSlice.notes)(Stop.value);
                        if ($1072) {
                            return {
                                note: child.note,
                                expl: RootExpl.value
                            };
                        };
                        return v(true);
                    };
                    return v(true);
                };
            };
        };
        if (p instanceof NoParents) {
            return {
                trans: seg.trans,
                op: seg.op,
                rslice: {
                    id: seg.rslice.id,
                    notes: seg.rslice.notes,
                    x: seg.rslice.x,
                    parents: NoParents.value
                }
            };
        };
        if (p instanceof VertParent) {
            return {
                trans: seg.trans,
                op: seg.op,
                rslice: {
                    id: seg.rslice.id,
                    x: seg.rslice.x,
                    parents: new VertParent(p.value0.id),
                    notes: map5(map(findUniqueVertExpl(p.value0)))(seg.rslice.notes)
                }
            };
        };
        if (p instanceof MergeParents) {
            return {
                trans: seg.trans,
                op: seg.op,
                rslice: {
                    id: seg.rslice.id,
                    x: seg.rslice.x,
                    parents: new MergeParents({
                        left: p.value0.left.id,
                        right: p.value0.right.id
                    }),
                    notes: map5(map(findUniqueMergeExpl(p.value0.left)(p.value0.right)))(seg.rslice.notes)
                }
            };
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 682, column 20 - line 697, column 8): " + [ p.constructor.name ]);
    };
};
var emptyStyle = {
    classes: "",
    label: ""
};
var styleSetClasses = function (classes) {
    return function (styleMaybe) {
        var style = Data_Maybe.fromMaybe(emptyStyle)(styleMaybe);
        var $1078 = Data_String_Common["null"](classes) && Data_String_Common["null"](style.label);
        if ($1078) {
            return Data_Maybe.Nothing.value;
        };
        return new Data_Maybe.Just({
            label: style.label,
            classes: classes
        });
    };
};
var styleSetLabel = function (label) {
    return function (styleMaybe) {
        var style = Data_Maybe.fromMaybe(emptyStyle)(styleMaybe);
        var $1079 = Data_String_Common["null"](label) && Data_String_Common["null"](style.classes);
        if ($1079) {
            return Data_Maybe.Nothing.value;
        };
        return new Data_Maybe.Just({
            classes: style.classes,
            label: label
        });
    };
};
var emptyEdges = /* #__PURE__ */ Data_Monoid.mempty(monoidRecord);
var emptyTrans = function (id) {
    return function (is2nd) {
        return {
            id: id,
            is2nd: is2nd,
            edges: emptyEdges
        };
    };
};
var explLeftEdge = function (v) {
    var edge = function (l) {
        return Data_Set.singleton({
            left: new Inner(l),
            right: new Inner(v.note)
        });
    };
    if (v.expl instanceof DoubleExpl) {
        if (v.expl.value0.orn instanceof Data_Maybe.Just && v.expl.value0.orn.value0 instanceof PassingRight) {
            return {
                regular: emptyEdges.regular,
                passing: [ {
                    left: new Inner(v.expl.value0.leftParent),
                    right: new Inner(v.note)
                } ]
            };
        };
        return {
            passing: emptyEdges.passing,
            regular: edge(v.expl.value0.leftParent)
        };
    };
    if (v.expl instanceof RightExpl) {
        return {
            passing: emptyEdges.passing,
            regular: edge(v.expl.value0.leftParent)
        };
    };
    if (v.expl instanceof RootExpl) {
        return {
            passing: emptyEdges.passing,
            regular: Data_Set.singleton({
                left: Start.value,
                right: new Inner(v.note)
            })
        };
    };
    return emptyEdges;
};
var explParentEdge = function (v) {
    if (v instanceof DoubleExpl) {
        var parentEdge = {
            left: new Inner(v.value0.leftParent),
            right: new Inner(v.value0.rightParent)
        };
        if (v.value0.orn instanceof Data_Maybe.Just && v.value0.orn.value0 instanceof PassingMid) {
            return {
                regular: emptyEdges.regular,
                passing: [ parentEdge ]
            };
        };
        if (v.value0.orn instanceof Data_Maybe.Just && v.value0.orn.value0 instanceof PassingLeft) {
            return {
                regular: emptyEdges.regular,
                passing: [ parentEdge ]
            };
        };
        if (v.value0.orn instanceof Data_Maybe.Just && v.value0.orn.value0 instanceof PassingRight) {
            return {
                regular: emptyEdges.regular,
                passing: [ parentEdge ]
            };
        };
        return {
            passing: emptyEdges.passing,
            regular: Data_Set.singleton(parentEdge)
        };
    };
    if (v instanceof RootExpl) {
        return {
            passing: emptyEdges.passing,
            regular: Data_Set.singleton({
                left: Start.value,
                right: Stop.value
            })
        };
    };
    return emptyEdges;
};
var explRightEdge = function (v) {
    var edge = function (r) {
        return Data_Set.singleton({
            left: new Inner(v.note),
            right: new Inner(r)
        });
    };
    if (v.expl instanceof DoubleExpl) {
        if (v.expl.value0.orn instanceof Data_Maybe.Just && v.expl.value0.orn.value0 instanceof PassingLeft) {
            return {
                regular: emptyEdges.regular,
                passing: [ {
                    left: new Inner(v.note),
                    right: new Inner(v.expl.value0.rightParent)
                } ]
            };
        };
        return {
            passing: emptyEdges.passing,
            regular: edge(v.expl.value0.rightParent)
        };
    };
    if (v.expl instanceof LeftExpl) {
        return {
            passing: emptyEdges.passing,
            regular: edge(v.expl.value0.rightParent)
        };
    };
    if (v.expl instanceof RootExpl) {
        return {
            passing: emptyEdges.passing,
            regular: Data_Set.singleton({
                left: new Inner(v.note),
                right: Stop.value
            })
        };
    };
    return emptyEdges;
};
var horiEdgesMid = function (slicel) {
    return function (edges) {
        return function (slicer) {
            var toLeft = foldl(function (acc) {
                return function (left) {
                    if (left.expl instanceof HoriExpl) {
                        return insert(left.expl.value0.id)(left.note)(acc);
                    };
                    return acc;
                };
            })(Data_Map_Internal.empty)(getInnerNotes(slicel));
            var toBoth = foldl(function (acc) {
                return function (right) {
                    if (right.expl instanceof HoriExpl) {
                        var v = lookup(right.expl.value0.id)(toLeft);
                        if (v instanceof Data_Maybe.Just) {
                            return insert4({
                                left: new Inner(v.value0),
                                right: new Inner(right.note)
                            })(acc);
                        };
                        if (v instanceof Data_Maybe.Nothing) {
                            return acc;
                        };
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 833, column 30 - line 835, column 27): " + [ v.constructor.name ]);
                    };
                    return acc;
                };
            })(Data_Set.empty)(getInnerNotes(slicer));
            return append3(edges)({
                passing: emptyEdges.passing,
                regular: toBoth
            });
        };
    };
};
var parentEdges = function (v) {
    if (v.notes instanceof Inner) {
        return foldMap(explParentEdge)(map(function (v1) {
            return v1.expl;
        })(v.notes.value0));
    };
    return emptyEdges;
};
var noteSetExplanation = function (noteId) {
    return function (expl) {
        return function (model) {
            var setNoteExplInSlice = function (slice) {
                return {
                    id: slice.id,
                    x: slice.x,
                    parents: slice.parents,
                    notes: map5(map(function (n) {
                        var $1120 = n.note.id === noteId;
                        if ($1120) {
                            return {
                                note: n.note,
                                expl: expl
                            };
                        };
                        return n;
                    }))(slice.notes)
                };
            };
            var noteInSlice = function (slice) {
                return Data_Array.any(function (n) {
                    return n.note.id === noteId;
                })(getInnerNotes(slice));
            };
            var doSegment$prime = function (upFromLeft) {
                return function (seg) {
                    if (seg.op instanceof Freeze) {
                        if (upFromLeft instanceof Data_List_Types.Nil) {
                            return new Data_Either.Right({
                                "seg'": seg,
                                rUp: Data_List_Types.Nil.value
                            });
                        };
                        if (upFromLeft instanceof Data_List_Types.Cons) {
                            return new Data_Either.Right({
                                "seg'": (function () {
                                    var $1123 = {};
                                    for (var $1124 in seg) {
                                        if ({}.hasOwnProperty.call(seg, $1124)) {
                                            $1123[$1124] = seg[$1124];
                                        };
                                    };
                                    $1123.trans = {
                                        id: seg.trans.id,
                                        is2nd: seg.trans.is2nd,
                                        edges: upFromLeft.value0
                                    };
                                    return $1123;
                                })(),
                                rUp: upFromLeft.value1
                            });
                        };
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 1286, column 15 - line 1288, column 86): " + [ upFromLeft.constructor.name ]);
                    };
                    if (seg.op instanceof Split) {
                        return bind3(doSegment(upFromLeft)(seg.op.value0.childl))(function (v) {
                            return bind3(doSegment$prime(v.rUp)(seg.op.value0.childr))(function (v1) {
                                var segNewOp = (function () {
                                    var $1130 = {};
                                    for (var $1131 in seg) {
                                        if ({}.hasOwnProperty.call(seg, $1131)) {
                                            $1130[$1131] = seg[$1131];
                                        };
                                    };
                                    $1130.op = new Split({
                                        childl: v["seg'"],
                                        childr: v1["seg'"]
                                    });
                                    return $1130;
                                })();
                                return bind3((function () {
                                    var $1133 = noteInSlice(seg.op.value0.childl.rslice);
                                    if ($1133) {
                                        var $1134 = explIsSplit(expl);
                                        if ($1134) {
                                            return pure3((function () {
                                                var $1135 = {};
                                                for (var $1136 in segNewOp) {
                                                    if ({}.hasOwnProperty.call(segNewOp, $1136)) {
                                                        $1135[$1136] = segNewOp[$1136];
                                                    };
                                                };
                                                $1135.trans = {
                                                    id: segNewOp.trans.id,
                                                    is2nd: segNewOp.trans.is2nd,
                                                    edges: parentEdges(v["seg'"].rslice)
                                                };
                                                return $1135;
                                            })());
                                        };
                                        return new Data_Either.Left("Cannot explain a split note with a hori.");
                                    };
                                    return pure3(segNewOp);
                                })())(function (seg$prime) {
                                    return pure3({
                                        "seg'": seg$prime,
                                        rUp: v1.rUp
                                    });
                                });
                            });
                        });
                    };
                    if (seg.op instanceof Hori) {
                        return bind3(doSegment(upFromLeft)(seg.op.value0.childl))(function (v) {
                            return bind3(doSegment(v.rUp)(seg.op.value0.childm))(function (v1) {
                                return bind3(doSegment$prime(v1.rUp)(seg.op.value0.childr))(function (v2) {
                                    return bind3(vertEdgesLeft(v["seg'"].trans.edges)(v["seg'"].rslice))(function (leftParentEdges) {
                                        return bind3(vertEdgesRight(v2["seg'"].trans.edges)(v1["seg'"].rslice))(function (rightParentEdges) {
                                            return discard2((function () {
                                                var $1148 = (noteInSlice(seg.op.value0.childl.rslice) || noteInSlice(seg.op.value0.childm.rslice)) && !explIsHori(expl);
                                                if ($1148) {
                                                    return new Data_Either.Left("Cannot explain a hori note with a split. noteId = " + (show1(noteId) + (", childl.rslice = " + (show6(seg.op.value0.childl.rslice) + (", childm.rslice = " + show6(seg.op.value0.childm.rslice))))));
                                                };
                                                return pure3(Data_Unit.unit);
                                            })())(function () {
                                                return pure3({
                                                    "seg'": (function () {
                                                        var $1149 = {};
                                                        for (var $1150 in seg) {
                                                            if ({}.hasOwnProperty.call(seg, $1150)) {
                                                                $1149[$1150] = seg[$1150];
                                                            };
                                                        };
                                                        $1149.op = new Hori({
                                                            childl: v["seg'"],
                                                            childm: v1["seg'"],
                                                            childr: v2["seg'"]
                                                        });
                                                        $1149.trans = {
                                                            id: seg.trans.id,
                                                            is2nd: seg.trans.is2nd,
                                                            edges: leftParentEdges
                                                        };
                                                        return $1149;
                                                    })(),
                                                    rUp: new Data_List_Types.Cons(rightParentEdges, v2.rUp)
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    };
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1285, column 31 - line 1327, column 12): " + [ seg.op.constructor.name ]);
                };
            };
            var doSegment = function (upFromLeft) {
                return function (seg) {
                    var rslice$prime = (function () {
                        var $1162 = noteInSlice(seg.rslice);
                        if ($1162) {
                            return setNoteExplInSlice(seg.rslice);
                        };
                        return seg.rslice;
                    })();
                    return map3(function (v) {
                        return {
                            rUp: v.rUp,
                            "seg'": {
                                op: v["seg'"].op,
                                trans: v["seg'"].trans,
                                rslice: rslice$prime
                            }
                        };
                    })(doSegment$prime(upFromLeft)(seg));
                };
            };
            var traverseTop = function (upFromLeft) {
                return function (v) {
                    if (v instanceof Data_List_Types.Nil) {
                        return new Data_Either.Right(Data_List_Types.Nil.value);
                    };
                    if (v instanceof Data_List_Types.Cons) {
                        return bind3(doSegment(upFromLeft)(v.value0))(function (v1) {
                            return bind3(traverseTop(v1.rUp)(v.value1))(function (rest$prime) {
                                return pure3(new Data_List_Types.Cons(v1["seg'"], rest$prime));
                            });
                        });
                    };
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1272, column 28 - line 1277, column 29): " + [ v.constructor.name ]);
                };
            };
            var v = traverseTop(Data_List_Types.Nil.value)(model.reduction.segments);
            if (v instanceof Data_Either.Right) {
                return new Data_Either.Right({
                    piece: model.piece,
                    styles: model.styles,
                    reduction: {
                        nextSliceId: model.reduction.nextSliceId,
                        nextTransId: model.reduction.nextTransId,
                        start: model.reduction.start,
                        segments: v.value0
                    }
                });
            };
            if (v instanceof Data_Either.Left) {
                return new Data_Either.Left(v.value0);
            };
            throw new Error("Failed pattern match at ProtoVoices.Model (line 1261, column 40 - line 1263, column 23): " + [ v.constructor.name ]);
        };
    };
};
var passingEdge = function (edge) {
    return {
        regular: emptyEdges.regular,
        passing: [ edge ]
    };
};
var regularEdge = function (edge) {
    return {
        passing: emptyEdges.passing,
        regular: Data_Set.singleton(edge)
    };
};
var edgeIds = function (v) {
    var getId = function (v1) {
        if (v1 instanceof Inner) {
            return v1.value0.id;
        };
        return show4(v1);
    };
    return new Data_Tuple.Tuple(getId(v.left), getId(v.right));
};
var doAt = function (match) {
    return function (f) {
        return function (red) {
            var go = function (v) {
                return function (v1) {
                    if (v1 instanceof Data_List_Types.Nil) {
                        return new Data_Either.Left("not found");
                    };
                    if (v1 instanceof Data_List_Types.Cons) {
                        var v2 = match(v1);
                        if (v2 instanceof Data_Maybe.Just) {
                            return map3(function (result) {
                                return append2(result)(v2.value0.value1);
                            })(f(v)(v2.value0.value0));
                        };
                        if (v2 instanceof Data_Maybe.Nothing) {
                            return map3(Data_List_Types.Cons.create(v1.value0))(go(v1.value0.rslice)(v1.value1));
                        };
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 677, column 39 - line 679, column 47): " + [ v2.constructor.name ]);
                    };
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 674, column 3 - line 674, column 62): " + [ v.constructor.name, v1.constructor.name ]);
                };
            };
            return go(red.start)(red.segments);
        };
    };
};
var detachSegment = function (v) {
    return {
        trans: v.trans,
        op: v.op
    };
};
var mkMerge = function (tid) {
    return function (leftSlice) {
        return function (seg1) {
            return function (seg2) {
                var pars = new MergeParents({
                    left: leftSlice,
                    right: seg2.rslice
                });
                var seg1$prime = setParents(pars)(seg1);
                var op = new Split({
                    childl: seg1$prime,
                    childr: detachSegment(seg2)
                });
                return {
                    trans: {
                        id: tid,
                        edges: parentEdges(seg1$prime.rslice),
                        is2nd: seg1.trans.is2nd
                    },
                    rslice: seg2.rslice,
                    op: op
                };
            };
        };
    };
};
var mergeAtSlice = function (sliceId) {
    return function (model) {
        var tryMerge = function (leftSlice) {
            return function (v) {
                return new Data_Either.Right(new Data_List_Types.Cons(mkMerge(model.reduction.nextTransId)(leftSlice)(v.seg1)(v.seg2), Data_List_Types.Nil.value));
            };
        };
        var matchSlice = function (v) {
            if (v instanceof Data_List_Types.Cons && v.value1 instanceof Data_List_Types.Cons) {
                var $1193 = eq10(v.value0.rslice.id)(sliceId);
                if ($1193) {
                    return new Data_Maybe.Just(new Data_Tuple.Tuple({
                        seg1: v.value0,
                        seg2: v.value1.value0
                    }, v.value1.value1));
                };
                return Data_Maybe.Nothing.value;
            };
            return Data_Maybe.Nothing.value;
        };
        var v = doAt(matchSlice)(tryMerge)(model.reduction);
        if (v instanceof Data_Either.Right) {
            return new Data_Either.Right({
                piece: model.piece,
                styles: model.styles,
                reduction: {
                    nextSliceId: model.reduction.nextSliceId,
                    start: model.reduction.start,
                    segments: v.value0,
                    nextTransId: incT(model.reduction.nextTransId)
                }
            });
        };
        if (v instanceof Data_Either.Left) {
            return new Data_Either.Left(v.value0);
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 857, column 30 - line 859, column 23): " + [ v.constructor.name ]);
    };
};
var defaultCSS = "";
var emptyStyles = /* #__PURE__ */ (function () {
    return {
        notes: Data_Map_Internal.empty,
        edges: Data_Map_Internal.empty,
        transitions: Data_Map_Internal.empty,
        slices: Data_Map_Internal.empty,
        css: defaultCSS,
        staff: GrandStaff.value
    };
})();
var loadPiece = function (piece) {
    return {
        piece: piece,
        reduction: thawPiece(piece),
        styles: emptyStyles
    };
};
var attachSegment = function (v) {
    return function (rslice) {
        return {
            trans: v.trans,
            op: v.op,
            rslice: rslice
        };
    };
};
var mkVert = function (v) {
    return function (v1) {
        return function (v2) {
            return function (v3) {
                return function (v4) {
                    if (v2.rslice.notes instanceof Inner && v3.rslice.notes instanceof Inner) {
                        if (!all(isRepeatingEdge)(v3.trans.edges.regular)) {
                            return new Data_Either.Left("Middle transition of a vert must only contain repetition and passing edges!");
                        };
                        if (Data_Boolean.otherwise) {
                            var newNotes = function (counts) {
                                var pitches = Data_Array.reverse(Data_Array.concatMap(function (v5) {
                                    return Data_Array.replicate(v5.value1)(v5.value0);
                                })(toUnfoldable1(counts)));
                                var mkNote = function (i) {
                                    return function (p) {
                                        return {
                                            note: {
                                                pitch: p,
                                                id: "note" + (show5(v1) + ("." + show(i)))
                                            },
                                            expl: NoExpl.value
                                        };
                                    };
                                };
                                return Data_Array.mapWithIndex(mkNote)(pitches);
                            };
                            var countPitches = function (notes) {
                                return foldl(function (counts) {
                                    return function (n) {
                                        return insertWith(add)(n.note.pitch)(1)(counts);
                                    };
                                })(Data_Map_Internal.empty)(notes);
                            };
                            var topSlice = {
                                notes: new Inner(newNotes(unionWith(max)(countPitches(v2.rslice.notes.value0))(countPitches(v3.rslice.notes.value0)))),
                                id: v1,
                                x: (v2.rslice.x + v3.rslice.x) / 2.0,
                                parents: NoParents.value
                            };
                            var childm = setParents(new VertParent(topSlice))(v3);
                            var mkLeftParent = function (lfound) {
                                var childl = setParents(new VertParent(topSlice))(attachSegment(lfound)(v2.rslice));
                                return bind3(vertEdgesLeft(lfound.trans.edges)(childl.rslice))(function (leftEdges) {
                                    return pure3({
                                        trans: {
                                            id: v,
                                            is2nd: false,
                                            edges: leftEdges
                                        },
                                        op: new Hori({
                                            childl: childl,
                                            childm: childm,
                                            childr: detachSegment(v4)
                                        })
                                    });
                                });
                            };
                            return bind3(vertEdgesRight(v4.trans.edges)(childm.rslice))(function (rightEdges) {
                                var rightParent = {
                                    trans: {
                                        id: incT(v),
                                        is2nd: true,
                                        edges: rightEdges
                                    },
                                    rslice: v4.rslice,
                                    op: Freeze.value
                                };
                                return pure3({
                                    mkLeftParent: mkLeftParent,
                                    rightParent: rightParent,
                                    topSlice: topSlice
                                });
                            });
                        };
                    };
                    return new Data_Either.Left("Cannot vert an outer slice!");
                };
            };
        };
    };
};
var undoMergeAtTrans = function (transId) {
    return function (model) {
        var tryUnmerge = function (v) {
            return function (seg) {
                if (seg.op instanceof Split) {
                    return new Data_Either.Right(new Data_List_Types.Cons(resetExpls(setParents(NoParents.value)(seg.op.value0.childl)), new Data_List_Types.Cons(attachSegment(seg.op.value0.childr)(seg.rslice), Data_List_Types.Nil.value)));
                };
                return new Data_Either.Left("Operation is not a split!");
            };
        };
        var matchTrans = function (v) {
            if (v instanceof Data_List_Types.Cons) {
                var $1224 = eq7(v.value0.trans.id)(transId);
                if ($1224) {
                    return new Data_Maybe.Just(new Data_Tuple.Tuple(v.value0, v.value1));
                };
                return Data_Maybe.Nothing.value;
            };
            return Data_Maybe.Nothing.value;
        };
        var v = doAt(matchTrans)(tryUnmerge)(model.reduction);
        if (v instanceof Data_Either.Right) {
            return new Data_Either.Right({
                piece: model.piece,
                styles: model.styles,
                reduction: {
                    nextSliceId: model.reduction.nextSliceId,
                    nextTransId: model.reduction.nextTransId,
                    start: model.reduction.start,
                    segments: v.value0
                }
            });
        };
        if (v instanceof Data_Either.Left) {
            return new Data_Either.Left(v.value0);
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 1086, column 34 - line 1088, column 23): " + [ v.constructor.name ]);
    };
};
var undoVertAtSlice = function (sliceId) {
    return function (model) {
        var tryReInsert = function (v) {
            return function (v1) {
                return function (v2) {
                    return new Data_Either.Right(new Data_List_Types.Cons(resetExpls(setParents(NoParents.value)({
                        trans: v2.pl.trans,
                        op: v2.pl.op,
                        rslice: v.slicel
                    })), new Data_List_Types.Cons(resetExpls(setParents(NoParents.value)(v.childm)), new Data_List_Types.Cons(attachSegment(v.childr)(v2.pr.rslice), Data_List_Types.Nil.value))));
                };
            };
        };
        var tryExtract = function (count) {
            return function (seg) {
                if (count <= 0) {
                    if (seg.op instanceof Hori) {
                        return pure3(new Data_Either.Right({
                            "seg'": detachSegment(seg.op.value0.childl),
                            result: {
                                slicel: seg.op.value0.childl.rslice,
                                childm: seg.op.value0.childm,
                                childr: seg.op.value0.childr,
                                "pl'": seg.op.value0.childl.trans.edges
                            }
                        }));
                    };
                    if (seg.op instanceof Freeze) {
                        return pure3(new Data_Either.Left(count));
                    };
                    return new Data_Either.Left("Could not find left parent edge. This is a bug!");
                };
                if (Data_Boolean.otherwise) {
                    if (seg.op instanceof Freeze) {
                        return pure3(new Data_Either.Left(count));
                    };
                    if (seg.op instanceof Split) {
                        return bind3(tryExtract(count)(seg.op.value0.childr))(function (resR) {
                            if (resR instanceof Data_Either.Right) {
                                return pure3(new Data_Either.Right({
                                    "seg'": {
                                        trans: seg.trans,
                                        op: new Split({
                                            childl: seg.op.value0.childl,
                                            childr: resR["value0"]["seg'"]
                                        })
                                    },
                                    result: resR.value0.result
                                }));
                            };
                            if (resR instanceof Data_Either.Left) {
                                return bind3(tryExtract(resR.value0 + 1 | 0)(detachSegment(seg.op.value0.childl)))(function (resL) {
                                    if (resL instanceof Data_Either.Right) {
                                        return pure3(new Data_Either.Right({
                                            "seg'": {
                                                trans: seg.trans,
                                                op: new Split({
                                                    childl: attachSegment(resL["value0"]["seg'"])(seg.op.value0.childl.rslice),
                                                    childr: seg.op.value0.childr
                                                })
                                            },
                                            result: resL.value0.result
                                        }));
                                    };
                                    if (resL instanceof Data_Either.Left) {
                                        return pure3(new Data_Either.Left(resL.value0));
                                    };
                                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1176, column 15 - line 1178, column 50): " + [ resL.constructor.name ]);
                                });
                            };
                            throw new Error("Failed pattern match at ProtoVoices.Model (line 1171, column 11 - line 1178, column 50): " + [ resR.constructor.name ]);
                        });
                    };
                    if (seg.op instanceof Hori) {
                        return bind3(tryExtract(count - 1 | 0)(seg.op.value0.childr))(function (resR) {
                            if (resR instanceof Data_Either.Right) {
                                return pure3(new Data_Either.Right({
                                    "seg'": {
                                        trans: seg.trans,
                                        op: new Hori({
                                            childl: seg.op.value0.childl,
                                            childm: seg.op.value0.childm,
                                            childr: resR["value0"]["seg'"]
                                        })
                                    },
                                    result: resR.value0.result
                                }));
                            };
                            if (resR instanceof Data_Either.Left) {
                                return bind3(tryExtract(resR.value0 + 1 | 0)(detachSegment(seg.op.value0.childm)))(function (resM) {
                                    if (resM instanceof Data_Either.Right) {
                                        return pure3(new Data_Either.Right({
                                            "seg'": {
                                                trans: seg.trans,
                                                op: new Hori({
                                                    childl: seg.op.value0.childl,
                                                    childm: attachSegment(resM["value0"]["seg'"])(seg.op.value0.childm.rslice),
                                                    childr: seg.op.value0.childr
                                                })
                                            },
                                            result: resM.value0.result
                                        }));
                                    };
                                    if (resM instanceof Data_Either.Left) {
                                        return bind3(tryExtract(resM.value0 + 1 | 0)(detachSegment(seg.op.value0.childl)))(function (resL) {
                                            if (resL instanceof Data_Either.Right) {
                                                return pure3(new Data_Either.Right({
                                                    "seg'": {
                                                        trans: seg.trans,
                                                        op: new Hori({
                                                            childl: attachSegment(resL["value0"]["seg'"])(seg.op.value0.childl.rslice),
                                                            childm: seg.op.value0.childm,
                                                            childr: seg.op.value0.childr
                                                        })
                                                    },
                                                    result: resL.value0.result
                                                }));
                                            };
                                            if (resL instanceof Data_Either.Left) {
                                                return pure3(new Data_Either.Left(resL.value0));
                                            };
                                            throw new Error("Failed pattern match at ProtoVoices.Model (line 1192, column 19 - line 1194, column 54): " + [ resL.constructor.name ]);
                                        });
                                    };
                                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1188, column 15 - line 1194, column 54): " + [ resM.constructor.name ]);
                                });
                            };
                            throw new Error("Failed pattern match at ProtoVoices.Model (line 1182, column 11 - line 1194, column 54): " + [ resR.constructor.name ]);
                        });
                    };
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1166, column 19 - line 1194, column 54): " + [ seg.op.constructor.name ]);
                };
                throw new Error("Failed pattern match at ProtoVoices.Model (line 1152, column 3 - line 1155, column 143): " + [ count.constructor.name, seg.constructor.name ]);
            };
        };
        var matchSlice = function (v) {
            if (v instanceof Data_List_Types.Cons && v.value1 instanceof Data_List_Types.Cons) {
                var $1279 = eq10(v.value0.rslice.id)(sliceId);
                if ($1279) {
                    return new Data_Maybe.Just(new Data_Tuple.Tuple({
                        pl: v.value0,
                        pr: v.value1.value0
                    }, v.value1.value1));
                };
                return Data_Maybe.Nothing.value;
            };
            return Data_Maybe.Nothing.value;
        };
        var insertPl = function (count) {
            return function (pl) {
                return function (seg) {
                    if (count <= 0) {
                        if (seg.op instanceof Freeze) {
                            return new Data_Either.Right({
                                "seg'": {
                                    op: seg.op,
                                    trans: {
                                        id: seg.trans.id,
                                        is2nd: seg.trans.is2nd,
                                        edges: pl
                                    }
                                },
                                "pl'": pl
                            });
                        };
                        return new Data_Either.Left("Invalid structure. This is a bug!");
                    };
                    if (Data_Boolean.otherwise) {
                        if (seg.op instanceof Freeze) {
                            return new Data_Either.Right({
                                "seg'": seg,
                                "pl'": pl
                            });
                        };
                        if (seg.op instanceof Split) {
                            return bind3(insertPl(count + 1 | 0)(pl)(detachSegment(seg.op.value0.childl)))(function (resL) {
                                return bind3(insertPl(count)(resL["pl'"])(seg.op.value0.childr))(function (resR) {
                                    return pure3({
                                        "seg'": {
                                            trans: seg.trans,
                                            op: new Split({
                                                childl: attachSegment(resL["seg'"])(seg.op.value0.childl.rslice),
                                                childr: resR["seg'"]
                                            })
                                        },
                                        "pl'": resR["pl'"]
                                    });
                                });
                            });
                        };
                        if (seg.op instanceof Hori) {
                            return bind3(insertPl(count + 1 | 0)(pl)(detachSegment(seg.op.value0.childl)))(function (resL) {
                                return bind3(insertPl(count)(resL["pl'"])(detachSegment(seg.op.value0.childm)))(function (resM) {
                                    var $1292 = count === 1;
                                    if ($1292) {
                                        return bind3(vertEdgesRight(resM["pl'"])(seg.op.value0.childm.rslice))(function (pl$prime) {
                                            return new Data_Either.Right({
                                                "seg'": {
                                                    trans: seg.trans,
                                                    op: new Hori({
                                                        childl: attachSegment(resL["seg'"])(seg.op.value0.childl.rslice),
                                                        childm: attachSegment(resM["seg'"])(seg.op.value0.childm.rslice),
                                                        childr: {
                                                            op: seg.op.value0.childr.op,
                                                            trans: {
                                                                id: seg.op.value0.childr.trans.id,
                                                                is2nd: seg.op.value0.childr.trans.is2nd,
                                                                edges: resM["pl'"]
                                                            }
                                                        }
                                                    })
                                                },
                                                "pl'": pl$prime
                                            });
                                        });
                                    };
                                    return bind3(insertPl(count - 1 | 0)(resM["pl'"])(seg.op.value0.childr))(function (resR) {
                                        return new Data_Either.Right({
                                            "seg'": {
                                                trans: seg.trans,
                                                op: new Hori({
                                                    childl: attachSegment(resL["seg'"])(seg.op.value0.childl.rslice),
                                                    childm: attachSegment(resM["seg'"])(seg.op.value0.childm.rslice),
                                                    childr: resR["seg'"]
                                                })
                                            },
                                            "pl'": resR["pl'"]
                                        });
                                    });
                                });
                            });
                        };
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 1211, column 19 - line 1247, column 16): " + [ seg.op.constructor.name ]);
                    };
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1206, column 3 - line 1206, column 95): " + [ count.constructor.name, pl.constructor.name, seg.constructor.name ]);
                };
            };
        };
        var fixPl = function (count) {
            return function (pl) {
                if (count >= 0) {
                    return function (v) {
                        if (v instanceof Data_List_Types.Nil) {
                            return pure3(Data_List_Types.Nil.value);
                        };
                        if (v instanceof Data_List_Types.Cons) {
                            return bind3(insertPl(count)(pl)(detachSegment(v.value0)))(function (v1) {
                                return bind3(fixPl(count - 1 | 0)(v1["pl'"])(v.value1))(function (tail$prime) {
                                    return pure3(new Data_List_Types.Cons(attachSegment(v1["seg'"])(v.value0.rslice), tail$prime));
                                });
                            });
                        };
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 1198, column 20 - line 1203, column 55): " + [ v.constructor.name ]);
                    };
                };
                if (Data_Boolean.otherwise) {
                    return pure3;
                };
                throw new Error("Failed pattern match at ProtoVoices.Model (line 1196, column 3 - line 1196, column 72): " + [ count.constructor.name, pl.constructor.name ]);
            };
        };
        var extractVert = function (v) {
            if (v instanceof Data_List_Types.Nil) {
                return new Data_Either.Left("Could not find hori!");
            };
            if (v instanceof Data_List_Types.Cons && v.value1 instanceof Data_List_Types.Nil) {
                return new Data_Either.Left("Could not find hori!");
            };
            if (v instanceof Data_List_Types.Cons && v.value1 instanceof Data_List_Types.Cons) {
                var $1308 = eq10(v.value0.rslice.id)(sliceId);
                if ($1308) {
                    var $1309 = eq16(v.value1.value0.op)(Freeze.value);
                    if ($1309) {
                        if (v.value0.op instanceof Hori) {
                            return new Data_Either.Right({
                                tail: new Data_List_Types.Cons({
                                    op: v.value0.op.value0.childl.op,
                                    trans: v.value0.op.value0.childl.trans,
                                    rslice: v.value0.rslice
                                }, new Data_List_Types.Cons(v.value1.value0, v.value1.value1)),
                                result: new Data_Either.Right({
                                    slicel: v.value0.op.value0.childl.rslice,
                                    childm: v.value0.op.value0.childm,
                                    childr: v.value0.op.value0.childr,
                                    "pl'": v.value0.op.value0.childl.trans.edges
                                }),
                                surfaceCount: 0
                            });
                        };
                        if (v.value0.op instanceof Freeze) {
                            return new Data_Either.Right({
                                tail: new Data_List_Types.Cons(v.value0, new Data_List_Types.Cons(v.value1.value0, v.value1.value1)),
                                result: new Data_Either.Left(1),
                                surfaceCount: 1
                            });
                        };
                        return new Data_Either.Left("Not a top-level hori!");
                    };
                    return new Data_Either.Left("Not a top-level hori!");
                };
                return bind3(extractVert(new Data_List_Types.Cons(v.value1.value0, v.value1.value1)))(function (next) {
                    if (next.result instanceof Data_Either.Right) {
                        return pure3({
                            tail: new Data_List_Types.Cons(v.value0, next.tail),
                            result: next.result,
                            surfaceCount: 0
                        });
                    };
                    if (next.result instanceof Data_Either.Left) {
                        return bind3(tryExtract(next.result.value0)(detachSegment(v.value0)))(function (pl$primeMaybe) {
                            if (pl$primeMaybe instanceof Data_Either.Left) {
                                return pure3({
                                    tail: new Data_List_Types.Cons(v.value0, next.tail),
                                    result: new Data_Either.Left(pl$primeMaybe.value0 + 1 | 0),
                                    surfaceCount: next.surfaceCount + 1 | 0
                                });
                            };
                            if (pl$primeMaybe instanceof Data_Either.Right) {
                                return bind3(fixPl(next.surfaceCount)(pl$primeMaybe["value0"]["result"]["pl'"])(new Data_List_Types.Cons(attachSegment(pl$primeMaybe["value0"]["seg'"])(v.value0.rslice), next.tail)))(function (fixedTail) {
                                    return pure3({
                                        tail: fixedTail,
                                        result: new Data_Either.Right(pl$primeMaybe.value0.result),
                                        surfaceCount: 0
                                    });
                                });
                            };
                            throw new Error("Failed pattern match at ProtoVoices.Model (line 1146, column 13 - line 1150, column 80): " + [ pl$primeMaybe.constructor.name ]);
                        });
                    };
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1142, column 9 - line 1150, column 80): " + [ next.result.constructor.name ]);
                });
            };
            throw new Error("Failed pattern match at ProtoVoices.Model (line 1112, column 17 - line 1150, column 80): " + [ v.constructor.name ]);
        };
        return bind3(extractVert(model.reduction.segments))(function (v) {
            if (v.result instanceof Data_Either.Right) {
                return bind3(doAt(matchSlice)(tryReInsert(v.result.value0))({
                    start: model.reduction.start,
                    nextTransId: model.reduction.nextTransId,
                    nextSliceId: model.reduction.nextSliceId,
                    segments: v.tail
                }))(function (segments$prime$prime) {
                    return pure3({
                        piece: model.piece,
                        styles: model.styles,
                        reduction: {
                            nextSliceId: model.reduction.nextSliceId,
                            nextTransId: model.reduction.nextTransId,
                            start: model.reduction.start,
                            segments: segments$prime$prime
                        }
                    });
                });
            };
            if (v.result instanceof Data_Either.Left) {
                return new Data_Either.Left("Could not find left parent edge. This is a bug!");
            };
            throw new Error("Failed pattern match at ProtoVoices.Model (line 1106, column 3 - line 1110, column 69): " + [ v.result.constructor.name ]);
        });
    };
};
var vertAtMid = function (transId) {
    return function (model) {
        var insertDangling = function (dist) {
            return function (topSlice) {
                return function (mkLeftParent) {
                    return function (leftSlice) {
                        return function (segl) {
                            return function (segr) {
                                return function (tail) {
                                    var v = function (v1) {
                                        if (Data_Boolean.otherwise) {
                                            var fixRight = function (childm) {
                                                return function (childr) {
                                                    return bind3(vertEdgesRight(childr.trans.edges)(childm.rslice))(function (edges$prime) {
                                                        return pure3({
                                                            op: segr.op,
                                                            rslice: segr.rslice,
                                                            trans: {
                                                                id: segr.trans.id,
                                                                is2nd: segr.trans.is2nd,
                                                                edges: edges$prime
                                                            }
                                                        });
                                                    });
                                                };
                                            };
                                            if (segl.op instanceof Freeze) {
                                                return new Data_Either.Right({
                                                    "segl'": segl,
                                                    "segr'": segr,
                                                    "tail'": tail,
                                                    leftover: new Data_Maybe.Just(0)
                                                });
                                            };
                                            if (segl.op instanceof Split) {
                                                return bind3(insertDangling(dist)(topSlice)(mkLeftParent)(segl.op.value0.childl.rslice)(attachSegment(segl.op.value0.childr)(segl.rslice))(segr)(tail))(function (v2) {
                                                    return bind3((function () {
                                                        var $1342 = dist === 0;
                                                        if ($1342) {
                                                            if (segl.op.value0.childl.rslice.parents instanceof MergeParents) {
                                                                return new Data_Either.Right(setParents(new MergeParents({
                                                                    left: leftSlice,
                                                                    right: topSlice
                                                                }))(resetExpls(segl.op.value0.childl)));
                                                            };
                                                            return new Data_Either.Left("invalid derivation structure: non-merge parents on merge slice");
                                                        };
                                                        return pure3(segl.op.value0.childl);
                                                    })())(function (childlFixed) {
                                                        if (v2.leftover instanceof Data_Maybe.Nothing) {
                                                            return pure3({
                                                                "segl'": {
                                                                    rslice: segl.rslice,
                                                                    op: new Split({
                                                                        childl: childlFixed,
                                                                        childr: detachSegment(v2["segl'"])
                                                                    }),
                                                                    trans: {
                                                                        id: segl.trans.id,
                                                                        is2nd: segl.trans.is2nd,
                                                                        edges: parentEdges(childlFixed.rslice)
                                                                    }
                                                                },
                                                                "segr'": v2["segr'"],
                                                                "tail'": v2["tail'"],
                                                                leftover: Data_Maybe.Nothing.value
                                                            });
                                                        };
                                                        if (v2.leftover instanceof Data_Maybe.Just) {
                                                            return bind3(insertDangling((dist + v2.leftover.value0 | 0) + 1 | 0)(topSlice)(mkLeftParent)(leftSlice)(childlFixed)(v2["segl'"])(new Data_List_Types.Cons(v2["segr'"], v2["tail'"])))(function (v3) {
                                                                if (v3["tail'"] instanceof Data_List_Types.Cons) {
                                                                    var segl$prime = {
                                                                        rslice: segl.rslice,
                                                                        op: new Split({
                                                                            childl: v3["segl'"],
                                                                            childr: detachSegment(v3["segr'"])
                                                                        }),
                                                                        trans: {
                                                                            id: segl.trans.id,
                                                                            is2nd: segl.trans.is2nd,
                                                                            edges: parentEdges(v3["segl'"].rslice)
                                                                        }
                                                                    };
                                                                    return pure3({
                                                                        "segl'": segl$prime,
                                                                        "segr'": v3["tail'"].value0,
                                                                        "tail'": v3["tail'"].value1,
                                                                        leftover: map4(function (v4) {
                                                                            return v4 + 1 | 0;
                                                                        })(v3.leftover)
                                                                    });
                                                                };
                                                                return new Data_Either.Left("Returned tail too short (splitLeft). This is a bug!");
                                                            });
                                                        };
                                                        throw new Error("Failed pattern match at ProtoVoices.Model (line 1003, column 13 - line 1029, column 82): " + [ v2.leftover.constructor.name ]);
                                                    });
                                                });
                                            };
                                            if (segl.op instanceof Hori) {
                                                if (segr.op instanceof Hori) {
                                                    return new Data_Either.Left("Not a leftmost derivation (Hori right of Hori)!");
                                                };
                                                if (segr.op instanceof Split) {
                                                    return bind3(insertDangling(dist)(topSlice)(mkLeftParent)(leftSlice)(segl)(segr.op.value0.childl)(new Data_List_Types.Cons(attachSegment(segr.op.value0.childr)(segr.rslice), tail)))(function (v2) {
                                                        if (v2["tail'"] instanceof Data_List_Types.Cons) {
                                                            var splitOp$prime = new Split({
                                                                childl: v2["segr'"],
                                                                childr: detachSegment(v2["tail'"].value0)
                                                            });
                                                            return pure3({
                                                                "segl'": v2["segl'"],
                                                                "segr'": {
                                                                    rslice: segr.rslice,
                                                                    op: splitOp$prime,
                                                                    trans: {
                                                                        id: segr.trans.id,
                                                                        is2nd: segr.trans.is2nd,
                                                                        edges: parentEdges(v2["segr'"].rslice)
                                                                    }
                                                                },
                                                                "tail'": v2["tail'"].value1,
                                                                leftover: v2.leftover
                                                            });
                                                        };
                                                        return new Data_Either.Left("Returned tail too short (splitRight). This is a bug!");
                                                    });
                                                };
                                                if (segr.op instanceof Freeze) {
                                                    if (tail instanceof Data_List_Types.Nil) {
                                                        return new Data_Either.Left("Tail too short (hori). This is a bug!");
                                                    };
                                                    if (tail instanceof Data_List_Types.Cons) {
                                                        return bind3(insertDangling(dist - 1 | 0)(topSlice)(mkLeftParent)(segl.op.value0.childm.rslice)(attachSegment(segl.op.value0.childr)(segl.rslice))(tail.value0)(tail.value1))(function (v2) {
                                                            var tail$primer = new Data_List_Types.Cons(v2["segr'"], v2["tail'"]);
                                                            if (v2.leftover instanceof Data_Maybe.Nothing) {
                                                                var op$prime = new Hori({
                                                                    childl: segl.op.value0.childl,
                                                                    childm: segl.op.value0.childm,
                                                                    childr: detachSegment(v2["segl'"])
                                                                });
                                                                return bind3(fixRight(segl.op.value0.childm)(v2["segl'"]))(function (segr$primer) {
                                                                    return pure3({
                                                                        "segl'": {
                                                                            rslice: segl.rslice,
                                                                            trans: segl.trans,
                                                                            op: op$prime
                                                                        },
                                                                        "segr'": segr$primer,
                                                                        "tail'": tail$primer,
                                                                        leftover: Data_Maybe.Nothing.value
                                                                    });
                                                                });
                                                            };
                                                            if (v2.leftover instanceof Data_Maybe.Just) {
                                                                return bind3(insertDangling(dist + v2.leftover.value0 | 0)(topSlice)(mkLeftParent)(segl.op.value0.childl.rslice)(segl.op.value0.childm)(v2["segl'"])(tail$primer))(function (v3) {
                                                                    if (v3.leftover instanceof Data_Maybe.Nothing) {
                                                                        var op$prime = new Hori({
                                                                            childl: segl.op.value0.childl,
                                                                            childm: v3["segl'"],
                                                                            childr: detachSegment(v3["segr'"])
                                                                        });
                                                                        return bind3(fixRight(v3["segl'"])(v3["segr'"]))(function (segr$primem) {
                                                                            return pure3({
                                                                                "segl'": {
                                                                                    rslice: segl.rslice,
                                                                                    trans: segl.trans,
                                                                                    op: op$prime
                                                                                },
                                                                                "segr'": segr$primem,
                                                                                "tail'": v3["tail'"],
                                                                                leftover: Data_Maybe.Nothing.value
                                                                            });
                                                                        });
                                                                    };
                                                                    if (v3.leftover instanceof Data_Maybe.Just) {
                                                                        return bind3(insertDangling((dist + 1 | 0) + v3.leftover.value0 | 0)(topSlice)(mkLeftParent)(leftSlice)(segl.op.value0.childl)(v3["segl'"])(new Data_List_Types.Cons(v3["segr'"], v3["tail'"])))(function (v4) {
                                                                            if (v4["tail'"] instanceof Data_List_Types.Nil) {
                                                                                return new Data_Either.Left("Returned tail too short (hori). This is a bug!");
                                                                            };
                                                                            if (v4["tail'"] instanceof Data_List_Types.Cons) {
                                                                                var op$prime = new Hori({
                                                                                    childl: v4["segl'"],
                                                                                    childm: v4["segr'"],
                                                                                    childr: detachSegment(v4["tail'"].value0)
                                                                                });
                                                                                return bind3(fixRight(v4["segr'"])(v4["tail'"].value0))(function (segr$primel) {
                                                                                    return pure3({
                                                                                        "segl'": {
                                                                                            rslice: segl.rslice,
                                                                                            trans: segl.trans,
                                                                                            op: op$prime
                                                                                        },
                                                                                        "segr'": segr$primel,
                                                                                        "tail'": v4["tail'"].value1,
                                                                                        leftover: map4(function (v5) {
                                                                                            return v5 + 2 | 0;
                                                                                        })(v4.leftover)
                                                                                    });
                                                                                });
                                                                            };
                                                                            throw new Error("Failed pattern match at ProtoVoices.Model (line 1072, column 25 - line 1078, column 119): " + [ v4["tail'"].constructor.name ]);
                                                                        });
                                                                    };
                                                                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1062, column 21 - line 1078, column 119): " + [ v3.leftover.constructor.name ]);
                                                                });
                                                            };
                                                            throw new Error("Failed pattern match at ProtoVoices.Model (line 1052, column 17 - line 1078, column 119): " + [ v2.leftover.constructor.name ]);
                                                        });
                                                    };
                                                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1044, column 23 - line 1078, column 119): " + [ tail.constructor.name ]);
                                                };
                                                throw new Error("Failed pattern match at ProtoVoices.Model (line 1031, column 46 - line 1078, column 119): " + [ segr.op.constructor.name ]);
                                            };
                                            throw new Error("Failed pattern match at ProtoVoices.Model (line 988, column 9 - line 1078, column 119): " + [ segl.op.constructor.name ]);
                                        };
                                        throw new Error("Failed pattern match at ProtoVoices.Model (line 912, column 1 - line 912, column 53): " + [ dist.constructor.name, topSlice.constructor.name, mkLeftParent.constructor.name, leftSlice.constructor.name, segl.constructor.name, segr.constructor.name, tail.constructor.name ]);
                                    };
                                    var $1409 = dist === 0;
                                    if ($1409) {
                                        var $1410 = !segl.trans.is2nd;
                                        if ($1410) {
                                            return bind3(mkLeftParent(detachSegment(segl)))(function (segl$prime) {
                                                return pure3({
                                                    "segl'": attachSegment(segl$prime)(segl.rslice),
                                                    "segr'": segr,
                                                    "tail'": tail,
                                                    leftover: Data_Maybe.Nothing.value
                                                });
                                            });
                                        };
                                        return v(true);
                                    };
                                    return v(true);
                                };
                            };
                        };
                    };
                };
            };
        };
        var tryInsert = function (dist) {
            return function (topSlice) {
                return function (mkLeftParent) {
                    return function (leftSlice) {
                        return function (segl) {
                            return function (segr) {
                                return function (tail) {
                                    return bind3(insertDangling(dist)(topSlice)(mkLeftParent)(leftSlice)(segl)(segr)(tail))(function (v) {
                                        return pure3((function () {
                                            if (v.leftover instanceof Data_Maybe.Nothing) {
                                                return {
                                                    "seg'": v["segl'"],
                                                    "tail'": new Data_List_Types.Cons(v["segr'"], v["tail'"]),
                                                    dangling: Data_Maybe.Nothing.value
                                                };
                                            };
                                            if (v.leftover instanceof Data_Maybe.Just) {
                                                return {
                                                    "seg'": v["segl'"],
                                                    "tail'": new Data_List_Types.Cons(v["segr'"], v["tail'"]),
                                                    dangling: new Data_Maybe.Just({
                                                        dist: (dist + 1 | 0) + v.leftover.value0 | 0,
                                                        mkLeftParent: mkLeftParent,
                                                        topSlice: topSlice
                                                    })
                                                };
                                            };
                                            throw new Error("Failed pattern match at ProtoVoices.Model (line 964, column 10 - line 966, column 120): " + [ v.leftover.constructor.name ]);
                                        })());
                                    });
                                };
                            };
                        };
                    };
                };
            };
        };
        var doVert = function (v) {
            return function (v1) {
                if (v1 instanceof Data_List_Types.Cons && (v1.value1 instanceof Data_List_Types.Cons && v1.value1.value1 instanceof Data_List_Types.Cons)) {
                    if (eq7(v1.value1.value0.trans.id)(transId)) {
                        return bind3(mkVert(model.reduction.nextTransId)(model.reduction.nextSliceId)(v1.value0)(v1.value1.value0)(v1.value1.value1.value0))(function (v2) {
                            return tryInsert(0)(v2.topSlice)(v2.mkLeftParent)(v)({
                                trans: v1.value0.trans,
                                op: v1.value0.op,
                                rslice: v2.topSlice
                            })(v2.rightParent)(v1.value1.value1.value1);
                        });
                    };
                    if (Data_Boolean.otherwise) {
                        return bind3(doVert(v1.value0.rslice)(v1.value1))(function (v2) {
                            if (v2.dangling instanceof Data_Maybe.Nothing) {
                                return new Data_Either.Right({
                                    "seg'": v1.value0,
                                    "tail'": new Data_List_Types.Cons(v2["seg'"], v2["tail'"]),
                                    dangling: Data_Maybe.Nothing.value
                                });
                            };
                            if (v2.dangling instanceof Data_Maybe.Just) {
                                return tryInsert(v2.dangling.value0.dist)(v2.dangling.value0.topSlice)(v2.dangling.value0.mkLeftParent)(v)(v1.value0)(v2["seg'"])(v2["tail'"]);
                            };
                            throw new Error("Failed pattern match at ProtoVoices.Model (line 944, column 9 - line 946, column 110): " + [ v2.dangling.constructor.name ]);
                        });
                    };
                };
                return new Data_Either.Left("Cannot hori at " + show2(transId));
            };
        };
        var v = doVert(model.reduction.start)(model.reduction.segments);
        if (v instanceof Data_Either.Right) {
            if (v.value0.dangling instanceof Data_Maybe.Nothing) {
                return new Data_Either.Right({
                    piece: model.piece,
                    styles: model.styles,
                    reduction: {
                        start: model.reduction.start,
                        segments: new Data_List_Types.Cons(v["value0"]["seg'"], v["value0"]["tail'"]),
                        nextTransId: incT(incT(model.reduction.nextTransId)),
                        nextSliceId: incS(model.reduction.nextSliceId)
                    }
                });
            };
            if (v.value0.dangling instanceof Data_Maybe.Just) {
                return new Data_Either.Left("Failed to insert hori!");
            };
            throw new Error("Failed pattern match at ProtoVoices.Model (line 914, column 38 - line 924, column 52): " + [ v.value0.dangling.constructor.name ]);
        };
        if (v instanceof Data_Either.Left) {
            return new Data_Either.Left(v.value0);
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 913, column 27 - line 925, column 23): " + [ v.constructor.name ]);
    };
};
export {
    RightRepeat,
    RightNeighbor,
    LeftRepeat,
    LeftNeighbor,
    FullNeighbor,
    FullRepeat,
    LeftRepeatOfRight,
    RightRepeatOfLeft,
    PassingMid,
    PassingLeft,
    PassingRight,
    NoExpl,
    RootExpl,
    HoriExpl,
    RightExpl,
    LeftExpl,
    DoubleExpl,
    explParentEdge,
    explLeftEdge,
    explRightEdge,
    parentEdges,
    explIsSplit,
    explIsHori,
    findLeftOrn,
    findRightOrn,
    pbetween,
    findDoubleOrn,
    setLeftExplParent,
    setRightExplParent,
    setHoriExplParent,
    explHasParent,
    explParents,
    Start,
    Inner,
    Stop,
    getInner,
    isRepeatingEdge,
    edgeIds,
    sortNotes,
    emptyEdges,
    regularEdge,
    passingEdge,
    SliceId,
    incS,
    TransId,
    incT,
    NoParents,
    VertParent,
    MergeParents,
    getParents,
    getInnerNotes,
    emptyTrans,
    transEdges,
    Freeze,
    Split,
    Hori,
    resetExpls,
    attachSegment,
    detachSegment,
    emptyStyle,
    styleSetClasses,
    styleSetLabel,
    TrebleStaff,
    BassStaff,
    GrandStaff,
    staffType2JS,
    stylesUpdateNote,
    stylesUpdateEdge,
    stylesUpdateSlice,
    stylesUpdateTrans,
    emptyStyles,
    defaultCSS,
    printSurface,
    showReduction,
    startSlice,
    thawTrans,
    thawSlice,
    thawPiece,
    loadPiece,
    doAt,
    setParents,
    vertEdgesLeft,
    vertEdgesRight,
    horiEdgesLeft,
    horiEdgesRight,
    horiEdgesMid,
    mkMerge,
    mergeAtSlice,
    mkVert,
    vertAtMid,
    undoMergeAtTrans,
    undoVertAtSlice,
    noteSetExplanation,
    setNoteStyle,
    setEdgeStyle,
    setSliceStyle,
    setTransStyle,
    eqRightOrnament,
    genericRightOrnament,
    showRightOrnament,
    eqLeftOrnament,
    genericLeftOrnament,
    showLeftOrnament,
    eqDoubleOrnament,
    genericDoubleOrnament,
    showDoubleOrnament,
    eqNoteExplanation,
    genericNoteExplanation,
    showNoteExplanation,
    eqStartStop,
    functorStartStop,
    ordStartStop,
    showStartStop,
    writeForeignStartStop,
    readForeignStartStop,
    showSliceId,
    eqSliceId,
    ordSliceId,
    readForeignSliceId,
    writeForeignSliceId,
    showTransId,
    eqTransId,
    ordTransId,
    readForeignTransId,
    writeForeignTransId,
    eqParents,
    genericParents,
    showParents,
    eqOp,
    genericOp,
    showOp,
    eqStaff,
    genericStaff,
    showStaff
};
